import React, { useState, useEffect } from 'react';
import { 
  signIn, 
  signOut, 
  getCurrentUser, 
  getProyectos, 
  createProyecto,
  updateProyecto,
  deleteProyecto,
  getTestimonios,
  createTestimonio,
  updateTestimonio,
  deleteTestimonio,
  getConfigAdmin,
  saveConfigAdmin,
  getInfoJavier,
  saveInfoJavier,
  uploadImage,
  deleteImage,
  getFaqs,
  getFaqsAdmin,
  createFaq,
  updateFaq,
  deleteFaq,
  changePassword
} from './supabaseConfig';

export default function JaviReparaWeb() {
  const [currentUser, setCurrentUser] = useState(null);
  const [loadingAuth, setLoadingAuth] = useState(true);
  const [adminEmail, setAdminEmail] = useState('');
  const [adminPass, setAdminPass] = useState('');
  const [loginError, setLoginError] = useState('');
  const [trabajos, setTrabajos] = useState([]);
  const [filtroCategoria, setFiltroCategoria] = useState('Todos');
  const [adminTab, setAdminTab] = useState('proyectos');
  const [editingProject, setEditingProject] = useState(null);
  const [newProject, setNewProject] = useState({ titulo: '', categoria: 'Reformas de Baños', descripcion: '', ubicacion: '', imagenAntes: null, imagenDespues: null, instagram_url: '' });
  const [previewAntes, setPreviewAntes] = useState(null);
  const [previewDespues, setPreviewDespues] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [javierData, setJavierData] = useState({ 
    experiencia: 15, 
    biografia: 'Con más de 15 años de experiencia en el sector de reformas y construcción, me dedico a transformar espacios con profesionalidad y atención al detalle.',
    foto: null
  });
  const [testimonios, setTestimonios] = useState([
    { id: 1, nombre: 'Cliente 1', contenido: 'Excelente trabajo, muy recomendable', aprobado: true },
    { id: 2, nombre: 'Cliente 2', contenido: 'Profesional y puntual', aprobado: true }
  ]);
  const [nuevoTestimonio, setNuevoTestimonio] = useState({ nombre: '', email: '', contenido: '', valoracion: 5 });
  const [adminData, setAdminData] = useState({
    nombre_completo: 'Javier García Pina',
    telefono: '+34 635 36 79 78',
    ciudad: 'Calafell',
    email_contacto: 'javirepara79@gmail.com'
  });
  const [pruebasSociales, setPruebasSociales] = useState({
    anos_experiencia: 15,
    num_reformas: 200,
    valoracion: 4.9
  });
  const [heroTextos, setHeroTextos] = useState({
    titulo: '',
    subtitulo: '',
    cta_texto: ''
  });
  const [mostrarPassword, setMostrarPassword] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [faqOpen, setFaqOpen] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [nuevaFaq, setNuevaFaq] = useState({ pregunta: '', respuesta: '' });
  const [editingFaq, setEditingFaq] = useState(null);
  const [privacidadOpen, setPrivacidadOpen] = useState(false);
  const [avisoLegalOpen, setAvisoLegalOpen] = useState(false);
  const [nuevaPassword, setNuevaPassword] = useState('');
  const [confirmarPassword, setConfirmarPassword] = useState('');
  const [mostrarVolverArriba, setMostrarVolverArriba] = useState(false);

  const showNotification = (message, type = 'success') => {
    const id = Date.now();
    const notification = { id, message, type };
    setNotifications(prev => [...prev, notification]);
    
    // Auto-cerrar después de 3 segundos
    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== id));
    }, 3000);
  };

  const renderTextoDestacado = (texto) => {
    if (!texto) return '';
    const partes = texto.split('*');
    return partes.map((parte, idx) => 
      idx % 2 === 1 ? <span key={idx} className="green">{parte}</span> : parte
    );
  };

  const loadFaqs = async (adminId = null) => {
    try {
      // Si hay adminId (admin logueado), cargar TODAS sus FAQs
      if (adminId) {
        const { data, error } = await getFaqsAdmin(adminId);
        if (error) throw error;
        setFaqs(data || []);
      } else {
        // Si no hay adminId (público), solo visibles
        const { data, error } = await getFaqs();
        if (error) throw error;
        setFaqs(data || []);
      }
    } catch (error) {
      console.error('Error cargando FAQs:', error);
    }
  };

  const agregarFaq = async () => {
    if (!nuevaFaq.pregunta || !nuevaFaq.respuesta) {
      showNotification('Completa pregunta y respuesta', 'error');
      return;
    }
    if (!currentUser) return;
    try {
      const maxOrden = faqs.length > 0 ? Math.max(...faqs.map(f => f.orden || 0)) : 0;
      const { error } = await createFaq({
        pregunta: nuevaFaq.pregunta,
        respuesta: nuevaFaq.respuesta,
        orden: maxOrden + 1,
        admin_id: currentUser.id
      });
      if (error) throw error;
      if (currentUser) { await loadFaqs(currentUser.id); } else { await loadFaqs(); }
      setNuevaFaq({ pregunta: '', respuesta: '' });
      showNotification('FAQ agregada', 'success');
    } catch (error) {
      console.error('Error agregando FAQ:', error);
      showNotification('Error al agregar FAQ', 'error');
    }
  };

  const eliminarFaq = async (id) => {
    if (!window.confirm('¿Eliminar esta pregunta?')) return;
    try {
      const { error } = await deleteFaq(id);
      if (error) throw error;
      if (currentUser) { await loadFaqs(currentUser.id); } else { await loadFaqs(); }
      showNotification('FAQ eliminada', 'info');
    } catch (error) {
      showNotification('Error al eliminar', 'error');
    }
  };

  const toggleVisibleFaq = async (id, currentVisible) => {
    try {
      const { error } = await updateFaq(id, { visible: !currentVisible });
      if (error) throw error;
      if (currentUser) { await loadFaqs(currentUser.id); } else { await loadFaqs(); }
      showNotification(currentVisible ? 'FAQ ocultada' : 'FAQ visible', 'info');
    } catch (error) {
      showNotification('Error al actualizar', 'error');
    }
  };

  const startEditFaq = (faq) => {
    setEditingFaq(faq);
    setNuevaFaq({ pregunta: faq.pregunta, respuesta: faq.respuesta });
  };

  const cancelEditFaq = () => {
    setEditingFaq(null);
    setNuevaFaq({ pregunta: '', respuesta: '' });
  };

  const saveEditFaq = async () => {
    if (!editingFaq || !nuevaFaq.pregunta || !nuevaFaq.respuesta) {
      showNotification('Completa pregunta y respuesta', 'error');
      return;
    }
    try {
      const { error } = await updateFaq(editingFaq.id, {
        pregunta: nuevaFaq.pregunta,
        respuesta: nuevaFaq.respuesta
      });
      if (error) throw error;
      if (currentUser) { await loadFaqs(currentUser.id); } else { await loadFaqs(); }
      cancelEditFaq();
      showNotification('FAQ actualizada', 'success');
    } catch (error) {
      showNotification('Error al actualizar FAQ', 'error');
    }
  };

  const cambiarPassword = async () => {
    if (!nuevaPassword || !confirmarPassword) {
      showNotification('Completa ambos campos', 'error');
      return;
    }
    if (nuevaPassword !== confirmarPassword) {
      showNotification('Las contraseñas no coinciden', 'error');
      return;
    }
    if (nuevaPassword.length < 8) {
      showNotification('Mínimo 8 caracteres', 'error');
      return;
    }
    try {
      const { error } = await changePassword(nuevaPassword);
      if (error) throw error;
      setNuevaPassword('');
      setConfirmarPassword('');
      showNotification('Contraseña actualizada', 'success');
    } catch (error) {
      showNotification('Error al cambiar contraseña', 'error');
    }
  };

  const handleLogoDoubleClick = () => {
    document.getElementById('loginModal').classList.add('active');
  };


  useEffect(() => { 
    checkUser();
    loadPublicData();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setMostrarVolverArriba(window.scrollY > 500);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Cargar FAQs después de que las funciones estén definidas
    const loadInitialFaqs = async () => {
      try {
        const { data } = await getFaqs();
        if (data) setFaqs(data);
      } catch (error) {
        console.error('Error cargando FAQs:', error);
      }
    };
    loadInitialFaqs();
  }, []);

  const loadPublicData = async () => {
    // Cargar proyectos públicos (sin userId)
    try {
      const { data: proyectosData } = await getProyectos();
      if (proyectosData) setTrabajos(proyectosData);
    } catch (error) {
      console.error('Error cargando proyectos públicos:', error);
    }

    // Cargar testimonios aprobados
    try {
      const { data: testimoniosData } = await getTestimonios();
      if (testimoniosData) {
        setTestimonios(testimoniosData.filter(t => t.aprobado));
      }
    } catch (error) {
      console.error('Error cargando testimonios:', error);
    }

    // Cargar info de Javier públicamente
    try {
      console.log('Cargando info Javier pública...');
      const { data: infoData, error: infoError } = await getInfoJavier();
      console.log('Info Javier recibida:', infoData, 'Error:', infoError);
      
      if (infoData) {
        const newJavierData = {
          experiencia: infoData.anos_experiencia || 15,
          biografia: infoData.biografia,
          foto: infoData.foto_url
        };
        console.log('Actualizando javierData con:', newJavierData);
        setJavierData(newJavierData);
      }
    } catch (error) {
      console.error('Error cargando info Javier:', error);
    }

    // Cargar config admin públicamente (para datos de contacto)
    try {
      const { data: configData } = await getConfigAdmin();
      if (configData) {
        setAdminData({
          nombre_completo: configData.nombre_completo,
          telefono: configData.telefono,
          ciudad: configData.ciudad,
          email_contacto: configData.email_contacto
        });
        setPruebasSociales({
          anos_experiencia: configData.anos_experiencia,
          num_reformas: configData.num_reformas,
          valoracion: configData.valoracion
        });
        setHeroTextos({
          titulo: configData.hero_titulo || 'Reformas en *Calafell*',
          subtitulo: configData.hero_subtitulo || 'Presupuesto gratis en 24h. Desde pequeñas reparaciones hasta reformas integrales.',
          cta_texto: configData.hero_cta_texto || '📞 Presupuesto Gratis 24h'
        });
      }
    } catch (error) {
      console.error('Error cargando config:', error);
    }
  };

  const checkUser = async () => {
    try {
      const user = await getCurrentUser();
      if (user) {
        setCurrentUser(user);
        loadProjects(user.id);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingAuth(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');
    
    if (!adminEmail || !adminPass) {
      setLoginError('Usuario y contraseña son obligatorios');
      return;
    }

    try {
      const { data, error } = await signIn(adminEmail, adminPass);
      
      if (error) {
        console.error('Login error:', error);
        setLoginError('Credenciales inválidas');
        return;
      }

      if (!data || !data.user) {
        setLoginError('No se recibieron datos del usuario');
        return;
      }

      setCurrentUser(data.user);
      setAdminEmail('');
      setAdminPass('');
      await loadProjects(data.user.id);
      await loadConfigAdmin(data.user.id);
      await loadInfoJavier(data.user.id);
      await loadTestimonios(data.user.id);
      await loadFaqs(data.user.id);
      document.getElementById('loginModal').classList.remove('active');
    } catch (error) {
      console.error('Catch error:', error);
      setLoginError('Error al iniciar sesión');
    }
  };

  const handleLogout = async () => {
    try {
      await signOut();
      setCurrentUser(null);
      setTrabajos([]);
    } catch (error) {
      console.error(error);
    }
  };

  const loadProjects = async (userId) => {
    try {
      // Cargar TODOS los proyectos (sin filtrar por admin)
      const { data, error } = await getProyectos(null);
      if (error) throw error;
      setTrabajos(data || []);
    } catch (error) {
      console.error('Error cargando proyectos:', error);
    }
  };

  const loadConfigAdmin = async (userId) => {
    try {
      const { data, error } = await getConfigAdmin(userId);
      if (error) throw error;
      if (data) {
        setAdminData({
          nombre_completo: data.nombre_completo,
          telefono: data.telefono,
          ciudad: data.ciudad,
          email_contacto: data.email_contacto
        });
        setPruebasSociales({
          anos_experiencia: data.anos_experiencia,
          num_reformas: data.num_reformas,
          valoracion: data.valoracion
        });
        setHeroTextos({
          titulo: data.hero_titulo || 'Reformas en *Calafell*',
          subtitulo: data.hero_subtitulo || 'Presupuesto gratis en 24h. Desde pequeñas reparaciones hasta reformas integrales.',
          cta_texto: data.hero_cta_texto || '📞 Presupuesto Gratis 24h'
        });
      }
    } catch (error) {
      console.error('Error cargando config:', error);
    }
  };

  const loadInfoJavier = async (userId) => {
    try {
      const { data, error } = await getInfoJavier(userId);
      if (error) throw error;
      if (data) {
        setJavierData({
          experiencia: data.anos_experiencia || 15,
          biografia: data.biografia,
          foto: data.foto_url
        });
      }
    } catch (error) {
      console.error('Error cargando info Javier:', error);
    }
  };

  const loadTestimonios = async (userId = null) => {
    console.log('=== Cargando testimonios ===');
    console.log('userId:', userId);
    try {
      const { data, error } = await getTestimonios(userId);
      console.log('Testimonios recibidos:', data, 'Error:', error);
      if (error) throw error;
      setTestimonios(data || []);
      console.log('Testimonios cargados:', data?.length || 0);
    } catch (error) {
      console.error('Error cargando testimonios:', error);
    }
  };

  const addProject = async () => {
    if (!newProject.titulo || !newProject.descripcion) {
      showNotification('Completa todos los campos', 'error');
      return;
    }
    
    if (!currentUser) {
      showNotification('Debes estar logueado', 'error');
      return;
    }

    console.log('=== Creando Proyecto ===');
    console.log('currentUser.id:', currentUser.id);

    try {
      let urlAntes = 'https://via.placeholder.com/400x300?text=Antes';
      let urlDespues = 'https://via.placeholder.com/400x300?text=Después';
      
      // Subir imagen ANTES si existe
      if (newProject.imagenAntes && newProject.imagenAntes instanceof File) {
        console.log('Subiendo imagen ANTES...');
        const { url, error } = await uploadImage(newProject.imagenAntes, 'antes');
        if (error) {
          showNotification('Error subiendo imagen ANTES', 'error');
          return;
        }
        urlAntes = url;
        console.log('URL Antes:', urlAntes);
      }
      
      // Subir imagen DESPUÉS si existe
      if (newProject.imagenDespues && newProject.imagenDespues instanceof File) {
        console.log('Subiendo imagen DESPUÉS...');
        const { url, error } = await uploadImage(newProject.imagenDespues, 'despues');
        if (error) {
          showNotification('Error subiendo imagen DESPUÉS', 'error');
          return;
        }
        urlDespues = url;
        console.log('URL Después:', urlDespues);
      }

      // Crear proyecto con URLs de Storage
      const proyectoData = {
        titulo: newProject.titulo,
        categoria: newProject.categoria,
        descripcion: newProject.descripcion,
        ubicacion: newProject.ubicacion,
        imagen_antes_url: urlAntes,
        imagen_despues_url: urlDespues,
        instagram_url: newProject.instagram_url || null,
        admin_id: currentUser.id
      };
      
      console.log('Datos a guardar:', proyectoData);

      const { data, error } = await createProyecto(proyectoData);
      
      console.log('Respuesta Supabase:', { data, error });

      if (error) throw error;
      
      await loadProjects(currentUser.id);
      setNewProject({ titulo: '', categoria: 'Reformas de Baños', descripcion: '', ubicacion: '', imagenAntes: null, imagenDespues: null, instagram_url: '' });
      setPreviewAntes(null);
      setPreviewDespues(null);
      showNotification('Proyecto guardado correctamente', 'success');
    } catch (error) {
      console.error('Error guardando proyecto:', error);
      showNotification('Error al guardar proyecto', 'error');
    }
  };

  const comprimirImagen = (file, maxWidth = 1200, quality = 0.8) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;
          
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }
          
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          
          canvas.toBlob((blob) => {
            resolve(new File([blob], file.name, { type: 'image/jpeg' }));
          }, 'image/jpeg', quality);
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  };

  const handleImagenAntes = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const comprimida = await comprimirImagen(file);
      setNewProject({...newProject, imagenAntes: comprimida});
      
      // Preview
      const reader = new FileReader();
      reader.onload = (event) => {
        setPreviewAntes(event.target.result);
      };
      reader.readAsDataURL(comprimida);
    }
  };

  const handleImagenDespues = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const comprimida = await comprimirImagen(file);
      setNewProject({...newProject, imagenDespues: comprimida});
      
      // Preview
      const reader = new FileReader();
      reader.onload = (event) => {
        setPreviewDespues(event.target.result);
      };
      reader.readAsDataURL(comprimida);
    }
  };

  const deleteProject = async (id) => {
    if (!window.confirm('¿Eliminar este proyecto?')) return;
    
    try {
      const { error } = await deleteProyecto(id);
      if (error) throw error;
      
      if (currentUser) {
        await loadProjects(currentUser.id);
      }
      showNotification('Proyecto eliminado', 'info');
    } catch (error) {
      console.error('Error eliminando proyecto:', error);
      showNotification('Error al eliminar proyecto', 'error');
    }
  };

  const startEditProject = (project) => {
    setEditingProject(project);
    setNewProject({
      titulo: project.titulo,
      categoria: project.categoria,
      descripcion: project.descripcion,
      ubicacion: project.ubicacion || '',
      imagenAntes: null,
      imagenDespues: null,
      instagram_url: project.instagram_url || ''
    });
    setPreviewAntes(project.imagen_antes_url);
    setPreviewDespues(project.imagen_despues_url);
  };

  const cancelEdit = () => {
    setEditingProject(null);
    setNewProject({ titulo: '', categoria: 'Reformas de Baños', descripcion: '', ubicacion: '', imagenAntes: null, imagenDespues: null, instagram_url: '' });
    setPreviewAntes(null);
    setPreviewDespues(null);
  };

  const saveEditProject = async () => {
    if (!editingProject || !currentUser) return;
    
    try {
      let urlAntes = editingProject.imagen_antes_url;
      let urlDespues = editingProject.imagen_despues_url;
      
      // Si hay nueva imagen ANTES
      if (newProject.imagenAntes && newProject.imagenAntes instanceof File) {
        const { url, error } = await uploadImage(newProject.imagenAntes, 'antes');
        if (error) throw error;
        urlAntes = url;
      }
      
      // Si hay nueva imagen DESPUÉS
      if (newProject.imagenDespues && newProject.imagenDespues instanceof File) {
        const { url, error } = await uploadImage(newProject.imagenDespues, 'despues');
        if (error) throw error;
        urlDespues = url;
      }
      
      const { error } = await updateProyecto(editingProject.id, {
        titulo: newProject.titulo,
        categoria: newProject.categoria,
        descripcion: newProject.descripcion,
        ubicacion: newProject.ubicacion,
        imagen_antes_url: urlAntes,
        imagen_despues_url: urlDespues,
        instagram_url: newProject.instagram_url || null
      });
      
      if (error) throw error;
      
      await loadProjects(currentUser.id);
      cancelEdit();
      showNotification('Proyecto actualizado', 'success');
    } catch (error) {
      console.error('Error actualizando proyecto:', error);
      showNotification('Error al actualizar proyecto', 'error');
    }
  };

  const updateAdminData = async () => {
    if (!currentUser) return;
    
    try {
      const config = {
        ...adminData,
        ...pruebasSociales,
        hero_titulo: heroTextos.titulo,
        hero_subtitulo: heroTextos.subtitulo,
        hero_cta_texto: heroTextos.cta_texto
      };
      
      const { error } = await saveConfigAdmin(currentUser.id, config);
      if (error) throw error;
      
      showNotification('Datos actualizados correctamente', 'success');
    } catch (error) {
      console.error('Error guardando config:', error);
      showNotification('Error al guardar datos', 'error');
    }
  };

  const handleFotoJavier = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const comprimida = await comprimirImagen(file, 800, 0.85);
      const reader = new FileReader();
      reader.onload = (event) => {
        setJavierData({...javierData, foto: event.target.result});
      };
      reader.readAsDataURL(comprimida);
    }
  };

  const borrarFotoJavier = () => {
    if (window.confirm('¿Eliminar la foto de Javier?')) {
      setJavierData({...javierData, foto: null});
      showNotification('Foto eliminada', 'info');
    }
  };

  const agregarTestimonio = async () => {
    if (!nuevoTestimonio.nombre || !nuevoTestimonio.email || !nuevoTestimonio.contenido) {
      showNotification('Completa todos los campos', 'error');
      return;
    }
    
    try {
      // Para usuarios públicos, usar el primer admin de la BD
      let adminId = currentUser ? currentUser.id : null;
      
      // Si no hay currentUser, obtener el primer admin de config_admin
      if (!adminId) {
        const { data: configData } = await getConfigAdmin();
        if (configData && configData.admin_id) {
          adminId = configData.admin_id;
        }
      }
      
      if (!adminId) {
        showNotification('Error: No se pudo determinar admin', 'error');
        return;
      }
      
      const { error } = await createTestimonio({
        nombre_cliente: nuevoTestimonio.nombre,
        email_cliente: nuevoTestimonio.email,
        contenido: nuevoTestimonio.contenido,
        valoracion: nuevoTestimonio.valoracion
      }, adminId);
      
      if (error) throw error;
      
      if (currentUser) {
        await loadTestimonios(currentUser.id);
      }
      
      setNuevoTestimonio({ nombre: '', email: '', contenido: '', valoracion: 5 });
      showNotification('Testimonio enviado para revisión', 'success');
    } catch (error) {
      console.error('Error guardando testimonio:', error);
      showNotification('Error al enviar testimonio', 'error');
    }
  };

  const aprobarTestimonio = async (id) => {
    try {
      const { error } = await updateTestimonio(id, { aprobado: true, estado: 'aprobado' });
      if (error) throw error;
      
      if (currentUser) {
        await loadTestimonios(currentUser.id);
      }
      showNotification('Testimonio aprobado', 'success');
    } catch (error) {
      console.error('Error aprobando testimonio:', error);
      showNotification('Error al aprobar', 'error');
    }
  };

  const rechazarTestimonio = async (id) => {
    try {
      const { error } = await updateTestimonio(id, { estado: 'rechazado', aprobado: false });
      if (error) throw error;
      
      if (currentUser) {
        await loadTestimonios(currentUser.id);
      }
      showNotification('Testimonio rechazado', 'info');
    } catch (error) {
      console.error('Error rechazando testimonio:', error);
      showNotification('Error al rechazar', 'error');
    }
  };

  const desaprobarTestimonio = async (id) => {
    try {
      const { error } = await updateTestimonio(id, { aprobado: false, estado: 'pendiente' });
      if (error) throw error;
      
      if (currentUser) {
        await loadTestimonios(currentUser.id);
      }
      showNotification('Testimonio marcado como pendiente', 'info');
    } catch (error) {
      showNotification('Error al desaprobar', 'error');
    }
  };

  const eliminarTestimonioDefinitivo = async (id) => {
    if (!window.confirm('¿Eliminar este testimonio definitivamente?')) return;
    
    try {
      const { error } = await deleteTestimonio(id);
      if (error) throw error;
      
      if (currentUser) {
        await loadTestimonios(currentUser.id);
      }
      showNotification('Testimonio eliminado', 'info');
    } catch (error) {
      showNotification('Error al eliminar', 'error');
    }
  };

  const guardarInfoJavier = async () => {
    console.log('=== Guardando Info Javier ===');
    console.log('currentUser:', currentUser);
    console.log('javierData:', javierData);
    
    if (!currentUser) {
      showNotification('Debes estar logueado', 'error');
      return;
    }
    
    try {
      const info = {
        biografia: javierData.biografia,
        foto_url: javierData.foto,
        anos_experiencia: javierData.experiencia
      };





      
      console.log('Datos a guardar:', info);
      
      const { data, error } = await saveInfoJavier(currentUser.id, info);
      
      console.log('Respuesta Supabase:', { data, error });
      
      if (error) throw error;
      showNotification('Información guardada', 'success');
    } catch (error) {
      console.error('Error guardando info Javier:', error);
      showNotification('Error al guardar', 'error');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formData = new FormData(e.target);
    
    try {
      const response = await fetch('https://formspree.io/f/mrerjnqe', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });
      
      if (response.ok) {
        showNotification('¡Mensaje enviado! Te contactaremos pronto', 'success');
        e.target.reset();
      } else {
        showNotification('Error al enviar mensaje. Intenta de nuevo', 'error');
      }
    } catch (error) {
      console.error('Error enviando formulario:', error);
      showNotification('Error de conexión. Intenta de nuevo', 'error');
    }
  };

  const scrollTo = (id) => {
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setMenuOpen(false); // Cerrar menú al navegar
      }
    }, 100);
  };

  if (loadingAuth) {
    return (
      <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
        <div style={{ width: '80px', height: '80px', background: 'linear-gradient(135deg, #10b981, #059669)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '36px', marginBottom: '16px', animation: 'pulse 1.5s ease-in-out infinite' }}>
          JR
        </div>
        <p style={{ fontSize: '14px', color: '#94a3b8' }}>Cargando...</p>
        <style>{`
          @keyframes pulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
        `}</style>
      </div>
    );
  }

  return (
    <div style={{ fontFamily: "'Inter', sans-serif", background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)', color: '#e2e8f0', minHeight: '100vh', width: '100%', maxWidth: '100vw', overflowX: 'hidden', margin: 0, padding: 0 }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=Inter:wght@300;400;500;600&display=swap');
        html { width: 100%; max-width: 100%; overflow-x: hidden; margin: 0; padding: 0; }
        body { width: 100%; max-width: 100%; overflow-x: hidden; overflow-y: auto; margin: 0; padding: 0; font-family: 'Inter', sans-serif; background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%); color: white; min-height: 100vh; }
        * { box-sizing: border-box; max-width: 100%; }
        h1, h2, h3 { font-family: 'Playfair Display', serif; font-weight: 700; }
        #root { width: 100%; max-width: 100%; overflow-x: hidden; }
        .container { width: 100%; max-width: 100%; margin: 0; padding: 0 16px; box-sizing: border-box; overflow-x: hidden; }
        @media (min-width: 640px) { .container { padding: 0 24px; } }
        @media (min-width: 1200px) { .container { max-width: 1200px; margin: 0 auto; } }
        nav { backdrop-filter: blur(20px); background: rgba(15, 23, 42, 0.95); border-bottom: 1px solid rgba(148, 163, 184, 0.1); position: fixed; top: 0; left: 0; right: 0; z-index: 30; width: 100%; max-width: 100%; overflow-x: hidden; }
        nav .container { display: flex; justify-content: space-between; align-items: center; height: auto; padding: 8px 16px !important; gap: 0; width: 100%; max-width: 100%; margin: 0; overflow-x: hidden; position: relative; }
        .reformas-centro { display: none; }
        @media (min-width: 1024px) { 
          .reformas-centro { 
            display: flex; 
            align-items: center; 
            gap: 12px; 
            position: absolute; 
            left: 50%; 
            transform: translateX(-50%); 
            pointer-events: none;
          } 
          .reformas-centro .separador { width: 1px; height: 28px; background: rgba(148, 163, 184, 0.3); }
          .reformas-centro span { font-size: 18px; font-weight: 600; color: #10b981; letter-spacing: 1.5px; }
        }
        .logo { display: flex; align-items: center; gap: 4px; cursor: pointer; flex-shrink: 0; margin: 0; }
        .logo > div:first-child { width: 40px; height: 40px; font-size: 18px; }
        .logo-text { display: none; margin: 0; }
        @media (min-width: 640px) { .logo-text { display: block; } .logo-text h1 { font-size: 12px; margin: 0; color: white; } .logo-text p { font-size: 8px; color: #10b981; margin: 0; } }
        @media (min-width: 1024px) { .logo-text h1 { font-size: 18px; font-weight: 700; } .logo-text p { display: none; } }
        @media (min-width: 1024px) { .logo-text h1 { font-size: 18px; font-weight: 700; } .logo-text p { display: none; } }
        .navbar-title { display: block; }
        @media (min-width: 768px) { .navbar-title { display: none !important; } }
        nav button { color: #cbd5e1; font-size: 9px; font-weight: 500; padding: 2px 4px; border: none; background: none; cursor: pointer; white-space: nowrap; transition: color 0.3s; margin: 0; line-height: 1; }
        @media (min-width: 640px) { nav button { font-size: 10px; padding: 3px 6px; } }
        @media (min-width: 768px) { nav button { font-size: 11px; padding: 4px 8px; } }
        @media (min-width: 1024px) { nav button { font-size: 13px; padding: 6px 12px; } }
        nav button:hover { color: #10b981; }
        nav > div:last-child { display: flex; gap: 2px; flex-wrap: wrap; align-content: flex-start; }
        @media (min-width: 640px) { nav > div:last-child { gap: 4px; } }
        
        /* Menú hamburguesa - SOLO MÓVIL */
        .hamburger-btn { display: flex; align-items: center; justify-content: center; background: none; border: none; color: white; font-size: 24px; cursor: pointer; padding: 6px; margin: 0; flex-shrink: 0; width: 40px; height: 40px; }
        @media (min-width: 768px) { .hamburger-btn { display: none; } }
        
        .desktop-menu { display: none; }
        @media (min-width: 768px) { .desktop-menu { display: flex; gap: 8px; } }
        
        .mobile-menu { display: block; background: linear-gradient(135deg, rgba(15,23,42,0.98), rgba(30,41,59,0.95)); border-top: 1px solid rgba(16, 185, 129, 0.3); padding: 8px 0; }
        @media (min-width: 768px) { .mobile-menu { display: none; } }
        .mobile-menu button { display: block; width: 100%; text-align: left; padding: 12px 24px; background: transparent; border: none; color: #cbd5e1; font-size: 14px; font-weight: 500; cursor: pointer; transition: all 0.2s; }
        .mobile-menu button:hover { background: rgba(16, 185, 129, 0.1); color: #10b981; }
        
        body { padding-top: 54px; }
        @media (min-width: 640px) { body { padding-top: 60px; } }
        .hero { padding: 60px 16px 40px; background: linear-gradient(135deg, rgba(15,23,42,0.8) 0%, rgba(51,65,85,0.6) 50%, rgba(30,136,104,0.1) 100%); text-align: center; position: relative; overflow: hidden; width: 100%; max-width: 100%; }
        @media (min-width: 768px) { .hero { padding: 120px 24px 80px; } }
        .hero h1 { font-size: 32px; line-height: 1.2; margin-bottom: 16px; color: white; max-width: 100%; word-wrap: break-word; }
        @media (min-width: 768px) { .hero h1 { font-size: 48px; } }
        @media (min-width: 1024px) { .hero h1 { font-size: 56px; } }
        .hero .green { background: linear-gradient(135deg, #10b981, #059669); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
        .hero p { font-size: 14px; color: #cbd5e1; margin-bottom: 24px; max-width: 600px; margin-left: auto; margin-right: auto; }
        @media (min-width: 768px) { .hero p { font-size: 18px; margin-bottom: 32px; } }
        @media (min-width: 1024px) { .hero p { font-size: 20px; } }
        .buttons { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; }
        @media (min-width: 768px) { .buttons { gap: 16px; } }
        .btn { padding: 12px 20px; border-radius: 8px; font-weight: 600; text-decoration: none; border: none; cursor: pointer; font-size: 13px; transition: all 0.3s; }
        @media (min-width: 768px) { .btn { padding: 14px 28px; font-size: 14px; } }
        @media (min-width: 1024px) { .btn { padding: 16px 32px; font-size: 14px; } }
        .btn-primary { background: linear-gradient(135deg, #10b981, #059669); color: white; box-shadow: 0 10px 30px rgba(16, 185, 129, 0.3); }
        .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 15px 40px rgba(16, 185, 129, 0.4); }
        .btn-secondary { border: 2px solid rgba(16, 185, 129, 0.5); color: #10b981; background: transparent; }
        .btn-secondary:hover { background: rgba(16, 185, 129, 0.1); }
        .section { padding: 48px 16px; scroll-margin-top: 80px; width: 100%; max-width: 100%; overflow-x: hidden; }
        @media (min-width: 640px) { .section { padding: 48px 24px; } }
        @media (min-width: 768px) { .section { padding: 80px 24px; scroll-margin-top: 100px; } }
        @media (min-width: 1024px) { .section { padding: 96px 24px; scroll-margin-top: 120px; } }
        
        /* Layout responsive sección Sobre */
        @media (min-width: 768px) { 
          .sobre-grid { grid-template-columns: 300px 1fr !important; gap: 48px !important; align-items: start !important; }
          .javier-info { text-align: left !important; }
        }
        
        /* Animaciones */
        @keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes slideDown { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }
        
        .section { animation: fadeIn 0.8s ease-out; }
        .mobile-menu { animation: slideDown 0.3s ease-out; }
        .btn { transition: all 0.3s ease; }
        .btn:hover { transform: translateY(-2px); }
        
        .section h2 { font-size: 32px; text-align: center; margin-bottom: 12px; color: white; }
        @media (min-width: 768px) { .section h2 { font-size: 42px; } }
        @media (min-width: 1024px) { .section h2 { font-size: 48px; } }
        .section p { text-align: center; color: #94a3b8; margin-bottom: 32px; font-size: 14px; }
        @media (min-width: 768px) { .section p { margin-bottom: 48px; font-size: 15px; } }
        #trabajos { background: rgba(15, 23, 42, 0.5); }
        .project { margin-bottom: 48px; }
        .project-header { margin-bottom: 24px; }
        .project-tag { display: inline-block; background: rgba(16, 185, 129, 0.2); color: #10b981; padding: 6px 16px; border-radius: 20px; font-size: 12px; font-weight: 600; margin-bottom: 12px; }
        .project h3 { font-size: 28px; color: white; margin-bottom: 8px; }
        .project-location { color: #10b981; font-size: 14px; }
        .project-desc { color: #cbd5e1; margin-top: 12px; }
        .gallery { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
        @media (max-width: 768px) { .gallery { grid-template-columns: 1fr; } }
        .gallery-item { position: relative; border-radius: 8px; overflow: hidden; height: 320px; }
        .gallery-item img { width: 100%; height: 100%; object-fit: cover; }
        .gallery-label { position: absolute; top: 12px; right: 12px; background: rgba(0, 0, 0, 0.6); color: white; padding: 6px 12px; border-radius: 4px; font-size: 11px; font-weight: 600; }
        #servicios { background: linear-gradient(135deg, rgba(51,65,85,0.2), rgba(30,41,59,0.2)); }
        .services { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 32px; }
        .service { position: relative; padding-left: 80px; }
        .service-number { position: absolute; left: 0; top: 0; font-size: 64px; color: rgba(16, 185, 129, 0.15); }
        .service h3 { color: white; margin-bottom: 12px; font-size: 20px; }
        .service p { color: #cbd5e1; line-height: 1.6; }
        #contacto { background: rgba(15, 23, 42, 0.5); }
        .contact-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 48px; }
        @media (max-width: 768px) { .contact-grid { grid-template-columns: 1fr; } }
        .contact-info { display: flex; gap: 24px; margin-bottom: 32px; }
        .contact-icon { width: 50px; height: 50px; background: rgba(16, 185, 129, 0.2); border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 28px; flex-shrink: 0; }
        .contact-text p { font-size: 12px; color: #94a3b8; margin-bottom: 4px; }
        .contact-text h4 { color: white; font-weight: 600; }
        form { display: flex; flex-direction: column; gap: 16px; }
        input, textarea { background: rgba(71, 85, 105, 0.5); border: 1px solid rgba(148, 163, 184, 0.3); border-radius: 8px; padding: 12px 16px; color: white; font-family: 'Inter', sans-serif; transition: all 0.3s; font-size: 14px; }
        input::placeholder, textarea::placeholder { color: #94a3b8; }
        input:focus, textarea:focus { border-color: #10b981; outline: none; background: rgba(71, 85, 105, 0.7); }
        .modal { display: none; position: fixed; inset: 0; background: rgba(0, 0, 0, 0.5); backdrop-filter: blur(5px); z-index: 50; align-items: center; justify-content: center; padding: 20px; }
        .modal.active { display: flex; }
        .modal-content { background: linear-gradient(135deg, rgba(51,65,85,0.9), rgba(30,41,59,0.9)); border: 1px solid rgba(148, 163, 184, 0.2); border-radius: 12px; padding: 32px; max-width: 500px; width: 100%; max-height: 90vh; overflow-y: auto; }
        .modal h2 { color: white; margin-bottom: 24px; font-size: 28px; }
        .modal input { width: 100%; }
        .error { color: #ff6b6b; font-size: 12px; margin-top: 4px; }
        
        /* Notificaciones Toast */
        .toast-container { position: fixed; top: 80px; right: 20px; z-index: 9999; display: flex; flex-direction: column; gap: 12px; max-width: 350px; pointer-events: none; }
        @media (max-width: 640px) { .toast-container { left: 20px; right: 20px; max-width: none; } }
        .toast { padding: 14px 18px; border-radius: 10px; color: white; font-size: 14px; font-weight: 500; box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2); animation: slideInToast 0.3s ease-out; display: flex; align-items: center; gap: 10px; pointer-events: auto; }
        .toast-success { background: linear-gradient(135deg, #10b981, #059669); }
        .toast-error { background: linear-gradient(135deg, #ef4444, #dc2626); }
        .toast-info { background: linear-gradient(135deg, #3b82f6, #2563eb); }
        @keyframes slideInToast { from { transform: translateX(400px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
        
        footer { text-align: center; padding: 24px 16px; border-top: 1px solid rgba(148, 163, 184, 0.1); color: #64748b; font-size: 11px; width: 100%; max-width: 100%; margin: 0; background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%); }
      `}</style>

      <nav>
        <div className="container">
          <div 
            className="logo" 
            onDoubleClick={handleLogoDoubleClick}
            style={{ cursor: 'pointer' }}
          >
            <div style={{ width: '40px', height: '40px', background: 'linear-gradient(135deg, #10b981, #059669)', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', color: 'white', fontSize: '18px', flexShrink: 0 }}>
              JR
            </div>
            <div className="logo-text">
              <h1>JAVIREPARA</h1>
              <p>REFORMAS</p>
            </div>
          </div>

          {/* REFORMAS centrado (solo PC) */}
          <div className="reformas-centro">
            <div className="separador"></div>
            <span>REFORMAS</span>
            <div className="separador"></div>
          </div>

          {/* Texto central en móvil - Click para volver al inicio */}
          <div 
            className="navbar-title" 
            onClick={() => scrollTo('inicio')}
            style={{ flex: 1, textAlign: 'center', display: 'block', color: 'white', fontSize: '14px', fontWeight: '600', fontFamily: "'Playfair Display', serif", cursor: 'pointer' }}
          >
            JAVIREPARA
          </div>
          
          {/* Desktop menu */}
          <div className="desktop-menu">
            <button onClick={() => scrollTo('sobre')}>Sobre Mí</button>
            <button onClick={() => scrollTo('trabajos')}>Proyectos</button>
            <button onClick={() => scrollTo('servicios')}>Servicios</button>
            <button onClick={() => scrollTo('testimonios')}>Testimonios</button>
            <button onClick={() => scrollTo('faq')}>FAQ</button>
            <button onClick={() => scrollTo('contacto')}>Contacto</button>
          </div>

          {/* Mobile hamburger button */}
          <button className="hamburger-btn" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>

        {/* Mobile menu dropdown */}
        {menuOpen && (
          <div className="mobile-menu">
            <button onClick={() => scrollTo('sobre')}>Sobre Mí</button>
            <button onClick={() => scrollTo('trabajos')}>Proyectos</button>
            <button onClick={() => scrollTo('servicios')}>Servicios</button>
            <button onClick={() => scrollTo('testimonios')}>Testimonios</button>
            <button onClick={() => scrollTo('faq')}>FAQ</button>
            <button onClick={() => scrollTo('contacto')}>Contacto</button>
          </div>
        )}
      </nav>

      <section id="inicio" className="hero">
        <div style={{ position: 'absolute', top: '-50px', right: '0', width: '400px', height: '400px', opacity: '0.06', pointerEvents: 'none', zIndex: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '150px', fontWeight: 'bold', color: '#10b981', overflow: 'hidden' }}>
          JR
        </div>
        <div className="container">
          <h1>{renderTextoDestacado(heroTextos.titulo)}</h1>
          <p>{heroTextos.subtitulo}</p>
          <div className="buttons">
            <button className="btn btn-primary" onClick={() => scrollTo('contacto')}>{heroTextos.cta_texto}</button>
            <button className="btn btn-secondary" onClick={() => scrollTo('trabajos')}>Ver Proyectos</button>
          </div>
          
          {/* Barra prueba social */}
          <div style={{ marginTop: '32px', padding: '12px 16px', background: 'rgba(16, 185, 129, 0.1)', border: '1px solid rgba(16, 185, 129, 0.3)', borderRadius: '8px', display: 'inline-block' }}>
            <p style={{ fontSize: '12px', color: '#cbd5e1', margin: 0, fontWeight: '500' }}>
              ⭐ {pruebasSociales.valoracion}/5 · {pruebasSociales.num_reformas}+ reformas · {pruebasSociales.anos_experiencia} años de experiencia
            </p>
          </div>
        </div>
      </section>

<section id="sobre" className="section" style={{ background: 'linear-gradient(135deg, rgba(51,65,85,0.2), rgba(30,41,59,0.2))' }}>
        <div className="container">
          <h2>Sobre Javier García</h2>
          <p>El profesional detrás de JAVIREPARA</p>
          
          {/* Layout responsive */}
          <div className="sobre-grid" style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '32px', marginTop: '32px' }}>
            
            {/* Foto */}
            <div style={{ textAlign: 'center' }}>
              {javierData.foto ? (
                <img 
                  src={javierData.foto} 
                  alt="Javier García" 
                  style={{ 
                    borderRadius: '12px', 
                    width: '100%', 
                    maxWidth: '280px', 
                    height: 'auto', 
                    margin: '0 auto', 
                    display: 'block',
                    border: '2px solid #10b981',
                    boxShadow: '0 8px 24px rgba(16, 185, 129, 0.25), 0 0 0 4px rgba(16, 185, 129, 0.08)'
                  }} 
                />
              ) : (
                <div style={{ background: 'rgba(51,65,85,0.3)', borderRadius: '12px', height: '280px', width: '280px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: '12px' }}>[Foto de Javier]</div>
              )}
            </div>

            {/* Info */}
            <div style={{ textAlign: 'center' }}>
              <h3 style={{ fontSize: '20px', color: 'white', marginBottom: '8px' }}>Javier García Pina</h3>
              <p style={{ color: '#10b981', fontSize: '14px', fontWeight: '600', marginBottom: '16px' }}>Reformista y Constructor Profesional</p>
              <p style={{ color: '#cbd5e1', marginBottom: '20px', lineHeight: '1.7', fontSize: '14px', maxWidth: '600px', margin: '0 auto 20px' }}>{javierData.biografia}</p>
              
              <div style={{ marginTop: '24px' }}>
                <h4 style={{ color: 'white', fontSize: '16px', marginBottom: '12px' }}>Especialidades</h4>
                <ul style={{ color: '#cbd5e1', listStyle: 'none', padding: '0', fontSize: '13px', textAlign: 'left', maxWidth: '500px', margin: '0 auto' }}>
                  <li style={{ marginBottom: '8px' }}>✓ Reformas integrales de viviendas</li>
                  <li style={{ marginBottom: '8px' }}>✓ Reformas especializadas de baños</li>
                  <li style={{ marginBottom: '8px' }}>✓ Reparaciones y mantenimiento</li>
                  <li style={{ marginBottom: '8px' }}>✓ Proyectos de construcción personalizados</li>
                </ul>
              </div>
              
              <div style={{ marginTop: '24px' }}>
                <h4 style={{ color: 'white', fontSize: '16px', marginBottom: '12px' }}>Valores</h4>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', maxWidth: '500px', margin: '0 auto' }}>
                  <div style={{ padding: '10px', background: 'rgba(16, 185, 129, 0.1)', borderRadius: '8px', borderLeft: '3px solid #10b981', textAlign: 'left' }}>
                    <p style={{ color: '#10b981', fontWeight: '600', marginBottom: '4px', fontSize: '12px' }}>Calidad</p>
                    <p style={{ color: '#94a3b8', fontSize: '11px', margin: 0 }}>Acabados impecables</p>
                  </div>
                  <div style={{ padding: '10px', background: 'rgba(16, 185, 129, 0.1)', borderRadius: '8px', borderLeft: '3px solid #10b981', textAlign: 'left' }}>
                    <p style={{ color: '#10b981', fontWeight: '600', marginBottom: '4px', fontSize: '12px' }}>Profesionalidad</p>
                    <p style={{ color: '#94a3b8', fontSize: '11px', margin: 0 }}>Puntualidad</p>
                  </div>
                  <div style={{ padding: '10px', background: 'rgba(16, 185, 129, 0.1)', borderRadius: '8px', borderLeft: '3px solid #10b981', textAlign: 'left' }}>
                    <p style={{ color: '#10b981', fontWeight: '600', marginBottom: '4px', fontSize: '12px' }}>Trato cercano</p>
                    <p style={{ color: '#94a3b8', fontSize: '11px', margin: 0 }}>Comunicación clara</p>
                  </div>
                  <div style={{ padding: '10px', background: 'rgba(16, 185, 129, 0.1)', borderRadius: '8px', borderLeft: '3px solid #10b981', textAlign: 'left' }}>
                    <p style={{ color: '#10b981', fontWeight: '600', marginBottom: '4px', fontSize: '12px' }}>Confianza</p>
                    <p style={{ color: '#94a3b8', fontSize: '11px', margin: 0 }}>Clientes satisfechos</p>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </section>


<section id="trabajos" className="section">
        <div className="container">
          <h2>Nuestros Proyectos</h2>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px', flexWrap: 'wrap', marginBottom: '8px' }}>
            <p style={{ margin: 0 }}>Galería de trabajos realizados</p>
            <a 
              href="https://www.instagram.com/javirepara_/reels/" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '6px 12px', background: 'linear-gradient(135deg, #475569, #334155)', color: 'white', borderRadius: '8px', textDecoration: 'none', fontSize: '12px', fontWeight: '600' }}
            >
              📷 Ver más en Instagram →
            </a>
          </div>
          
          {/* Filtros de categoría */}
          <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '32px' }}>
            {['Todos', 'Reformas de Baños', 'Reformas de Cocinas', 'Reformas Integrales', 'Construcción', 'Mantenimiento'].map(cat => (
              <button
                key={cat}
                onClick={() => setFiltroCategoria(cat)}
                style={{
                  padding: '8px 16px',
                  background: filtroCategoria === cat ? 'linear-gradient(135deg, #10b981, #059669)' : 'rgba(51, 65, 85, 0.4)',
                  color: 'white',
                  border: filtroCategoria === cat ? 'none' : '1px solid rgba(148, 163, 184, 0.3)',
                  borderRadius: '20px',
                  cursor: 'pointer',
                  fontSize: '11px',
                  fontWeight: '600',
                  transition: 'all 0.3s'
                }}
              >
                {cat}
              </button>
            ))}
          </div>

          {trabajos.filter(p => filtroCategoria === 'Todos' || p.categoria === filtroCategoria).length > 0 ? (
            trabajos.filter(p => filtroCategoria === 'Todos' || p.categoria === filtroCategoria).map(p => (
              <div key={p.id} className="project">
                <div className="project-header">
                  <span className="project-tag">{p.categoria}</span>
                  <h3>{p.titulo}</h3>
                  {p.ubicacion && <p className="project-location">📍 {p.ubicacion}</p>}
                  <p className="project-desc">{p.descripcion}</p>
                </div>
                {/* Galería de fotos antes/después */}
                <div className="gallery">
                  <div className="gallery-item">
                    <img src={p.imagen_antes_url} alt="Antes" />
                    <div className="gallery-label">ANTES</div>
                  </div>
                  <div className="gallery-item">
                    <img src={p.imagen_despues_url} alt="Después" />
                    <div className="gallery-label">DESPUÉS</div>
                  </div>
                </div>
                
                {/* Botón Instagram si hay link */}
                {p.instagram_url && (
                  <div style={{ textAlign: 'center', marginTop: '16px' }}>
                    <a 
                      href={p.instagram_url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{ display: 'inline-block', padding: '10px 20px', background: 'linear-gradient(135deg, #475569, #334155)', color: 'white', borderRadius: '8px', textDecoration: 'none', fontSize: '13px', fontWeight: '600' }}
                    >
                      📷 Ver más en Instagram →
                    </a>
                  </div>
                )}
              </div>
            ))
          ) : (
            <p style={{ textAlign: 'center', color: '#94a3b8', marginTop: '48px' }}>
              {trabajos.length === 0 ? 'Agrega proyectos desde el panel admin' : `No hay proyectos en la categoría "${filtroCategoria}"`}
            </p>
          )}
        </div>
      </section>

<section id="servicios" className="section">
        <div className="container">
          <h2>Nuestros Servicios</h2>
          <p>Soluciones profesionales adaptadas a tus necesidades</p>
          <div className="services">
            <div className="service">
              <span className="service-number">01</span>
              <h3>Manitas por Hora</h3>
              <p>Reparaciones rápidas: enchufes, grifos, cerraduras y pequeños arreglos.</p>
            </div>
            <div className="service">
              <span className="service-number">02</span>
              <h3>Reformas de Baños</h3>
              <p>Proyectos completos con diseño personalizado e instalaciones profesionales.</p>
            </div>
            <div className="service">
              <span className="service-number">03</span>
              <h3>Reformas Integrales</h3>
              <p>Transformación completa de viviendas, habitaciones y espacios.</p>
            </div>
            <div className="service">
              <span className="service-number">04</span>
              <h3>Construcción</h3>
              <p>Ampliaciones, nuevas construcciones y estructuras personalizadas.</p>
            </div>
          </div>
        </div>
      </section>

<section id="testimonios" className="section" style={{ background: 'linear-gradient(135deg, rgba(51,65,85,0.2), rgba(30,41,59,0.2))' }}>
        <div className="container">
          <h2>Lo que dicen nuestros clientes</h2>
          <p>Reseñas de clientes satisfechos con nuestro trabajo</p>
          
          {/* TESTIMONIOS APROBADOS */}
          {testimonios.filter(t => t.aprobado).length > 0 && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px', marginBottom: '48px' }}>
              {testimonios.filter(t => t.aprobado).map(t => (
                <div key={t.id} style={{ background: 'linear-gradient(135deg, rgba(51,65,85,0.4), rgba(30,41,59,0.3))', border: '1px solid rgba(16, 185, 129, 0.3)', borderLeft: '3px solid #10b981', borderRadius: '12px', padding: '24px' }}>
                  <div style={{ display: 'flex', gap: '4px', marginBottom: '12px' }}>
                    {[1, 2, 3, 4, 5].map(star => (
                      <span key={star} style={{ color: star <= (t.valoracion || 5) ? '#fbbf24' : '#4b5563', fontSize: '18px' }}>★</span>
                    ))}
                  </div>
                  <p style={{ color: 'white', fontWeight: '600', fontSize: '15px', marginBottom: '12px' }}>{t.nombre_cliente || t.nombre}</p>
                  <p style={{ color: '#cbd5e1', marginBottom: '16px', fontStyle: 'italic', lineHeight: '1.6' }}>"{t.contenido}"</p>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '12px', borderTop: '1px solid rgba(148, 163, 184, 0.2)' }}>
                    <p style={{ fontSize: '11px', color: '#94a3b8', margin: 0, fontStyle: 'italic' }}>Cliente verificado</p>
                    <p style={{ fontSize: '11px', color: '#94a3b8', margin: 0 }}>{new Date(t.created_at).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* FORMULARIO PARA NUEVO TESTIMONIO */}
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <h3 style={{ color: 'white', textAlign: 'center', marginBottom: '24px', fontSize: '24px' }}>Cuéntanos tu experiencia</h3>
            <div style={{ background: 'linear-gradient(135deg, rgba(51,65,85,0.4), rgba(30,41,59,0.3))', border: '1px solid rgba(16, 185, 129, 0.3)', borderRadius: '12px', padding: '24px' }}>
              <div style={{ display: 'grid', gap: '16px' }}>
                <input 
                  type="text" 
                  placeholder="Tu nombre" 
                  value={nuevoTestimonio.nombre}
                  onChange={(e) => setNuevoTestimonio({...nuevoTestimonio, nombre: e.target.value})}
                  style={{ padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white' }}
                />
                <input 
                  type="email" 
                  placeholder="Tu email" 
                  value={nuevoTestimonio.email}
                  onChange={(e) => setNuevoTestimonio({...nuevoTestimonio, email: e.target.value})}
                  style={{ padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white' }}
                />
                
                {/* Selector de Estrellas */}
                <div>
                  <label style={{ display: 'block', color: '#cbd5e1', fontSize: '13px', marginBottom: '8px', fontWeight: '600' }}>Tu valoración</label>
                  <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                    {[1, 2, 3, 4, 5].map(star => (
                      <button
                        key={star}
                        type="button"
                        onClick={() => setNuevoTestimonio({...nuevoTestimonio, valoracion: star})}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '32px', padding: '4px', transition: 'transform 0.2s' }}
                      >
                        <span style={{ color: star <= nuevoTestimonio.valoracion ? '#fbbf24' : '#4b5563' }}>★</span>
                      </button>
                    ))}
                  </div>
                  <p style={{ color: '#94a3b8', fontSize: '11px', textAlign: 'center', marginTop: '4px' }}>
                    {nuevoTestimonio.valoracion} {nuevoTestimonio.valoracion === 1 ? 'estrella' : 'estrellas'}
                  </p>
                </div>
                
                <textarea id="tu_testimonio_(máx_300_caracteres)" name="tu_testimonio_(máx_300_caracteres)" placeholder="Tu testimonio (máx 300 caracteres)" 
                  value={nuevoTestimonio.contenido}
                  onChange={(e) => {
                    if (e.target.value.length <= 300) {
                      setNuevoTestimonio({...nuevoTestimonio, contenido: e.target.value});
                    }
                  }}
                  rows="4"
                  style={{ padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', fontFamily: 'Inter' }}
                />
                <p style={{ color: '#94a3b8', fontSize: '12px' }}>{nuevoTestimonio.contenido.length}/300 caracteres</p>
                
                {/* Checkbox RGPD */}
                <label style={{ display: 'flex', alignItems: 'start', gap: '8px', marginBottom: '12px', cursor: 'pointer' }}>
                  <input type="checkbox" required style={{ marginTop: '3px', cursor: 'pointer', accentColor: '#10b981' }} />
                  <span style={{ fontSize: '10px', color: '#94a3b8', lineHeight: '1.4' }}>
                    Acepto la <a href="#" onClick={(e) => { e.preventDefault(); setPrivacidadOpen(true); }} style={{ color: '#10b981', textDecoration: 'underline', cursor: 'pointer' }}>política de privacidad</a> y que mi testimonio sea publicado.
                  </span>
                </label>
                
                <button 
                  onClick={agregarTestimonio}
                  style={{ padding: '12px 24px', background: 'linear-gradient(135deg, #10b981, #059669)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}
                >
                  ✓ Enviar Testimonio
                </button>
              </div>
              <p style={{ color: '#94a3b8', fontSize: '12px', marginTop: '16px', textAlign: 'center' }}>Tu testimonio será revisado y publicado tras validación</p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN FAQ */}
      <section id="faq" className="section">
        <div className="container">
          <h2>Preguntas Frecuentes</h2>
          <p>Resuelve tus dudas sobre nuestros servicios</p>
          
          <div style={{ maxWidth: '800px', margin: '0 auto', marginTop: '32px' }}>
            {faqs.map((faq, idx) => (
              <div 
                key={idx}
                style={{ 
                  background: 'linear-gradient(135deg, rgba(51,65,85,0.3), rgba(30,41,59,0.2))', 
                  border: '1px solid rgba(148, 163, 184, 0.2)', 
                  borderRadius: '10px', 
                  marginBottom: '12px',
                  overflow: 'hidden'
                }}
              >
                <button
                  onClick={() => setFaqOpen(faqOpen === idx ? null : idx)}
                  style={{ 
                    width: '100%', 
                    padding: '16px 20px', 
                    background: 'transparent', 
                    border: 'none', 
                    color: 'white', 
                    textAlign: 'left', 
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '14px',
                    fontWeight: '600'
                  }}
                >
                  <span>{faq.pregunta}</span>
                  <span style={{ fontSize: '18px', color: '#10b981', flexShrink: 0, marginLeft: '12px' }}>{faqOpen === idx ? '−' : '+'}</span>
                </button>
                {faqOpen === idx && (
                  <div style={{ padding: '0 20px 16px', color: '#cbd5e1', fontSize: '13px', lineHeight: '1.6', borderTop: '1px solid rgba(148, 163, 184, 0.1)', paddingTop: '12px' }}>
                    {faq.respuesta}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

<section id="contacto" className="section">
        <div className="container">
          <h2>Ponte en Contacto</h2>
          <p>Solicita tu presupuesto sin compromiso</p>
          
          {/* Dos columnas: Botones + Info */}
          <div style={{ display: 'grid', gridTemplateColumns: '45% 55%', gap: '12px', marginBottom: '24px' }}>
            
            {/* Columna izquierda: Botones */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <a 
                href={`tel:${adminData.telefono.replace(/\s/g, '')}`}
                style={{ background: 'linear-gradient(135deg, #10b981, #059669)', color: 'white', border: 'none', borderRadius: '10px', padding: '14px 12px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', textDecoration: 'none' }}
              >
                <span style={{ fontSize: '20px' }}>📱</span>
                <span>Llamar</span>
              </a>
              
              <a
                href={`https://wa.me/${adminData.telefono.replace(/\s/g, '').replace(/^\+/, '')}?text=Hola, estoy interesado en sus servicios`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ background: '#25d366', color: 'white', border: 'none', borderRadius: '10px', padding: '14px 12px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', textDecoration: 'none' }}
              >
                <span style={{ fontSize: '20px' }}>💬</span>
                <span>WhatsApp</span>
              </a>
            </div>

            {/* Columna derecha: Info */}
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '10px', padding: '10px', background: 'rgba(51, 65, 85, 0.3)', borderRadius: '8px', borderLeft: '3px solid #10b981' }}>
              <div>
                <p style={{ fontSize: '9px', color: '#94a3b8', margin: '0 0 2px 0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Teléfono</p>
                <p style={{ fontSize: '12px', color: 'white', margin: '0', fontWeight: '600' }}>{adminData.telefono}</p>
              </div>
              
              <div>
                <p style={{ fontSize: '9px', color: '#94a3b8', margin: '0 0 2px 0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Ubicación</p>
                <p style={{ fontSize: '12px', color: 'white', margin: '0', fontWeight: '600' }}>{adminData.ciudad}</p>
              </div>
              
              <div>
                <p style={{ fontSize: '9px', color: '#94a3b8', margin: '0 0 2px 0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Email</p>
                <p style={{ fontSize: '10px', color: 'white', margin: '0', fontWeight: '500', wordBreak: 'break-all', lineHeight: '1.3' }}>{adminData.email_contacto}</p>
              </div>
            </div>
          </div>

          {/* Formulario debajo */}
          <div style={{ background: 'rgba(51, 65, 85, 0.2)', borderRadius: '12px', padding: '20px 16px', border: '1px solid rgba(148, 163, 184, 0.2)' }}>
            <p style={{ textAlign: 'center', color: 'white', fontSize: '13px', fontWeight: '600', margin: '0 0 14px 0' }}>O déjanos un mensaje</p>
            <form onSubmit={handleSubmit}>
              <input type="text" name="tu_nombre" placeholder="Tu nombre" required style={{ width: '100%', padding: '10px 12px', marginBottom: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', fontSize: '13px', boxSizing: 'border-box' }} />
              <input type="email" name="tu_email" placeholder="Tu email" required style={{ width: '100%', padding: '10px 12px', marginBottom: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', fontSize: '13px', boxSizing: 'border-box' }} />
              <input type="tel" name="tu_teléfono" placeholder="Tu teléfono" style={{ width: '100%', padding: '10px 12px', marginBottom: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', fontSize: '13px', boxSizing: 'border-box' }} />
              <textarea id="tu_mensaje" name="tu_mensaje" placeholder="Tu mensaje" rows="3" required style={{ width: '100%', padding: '10px 12px', marginBottom: '12px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', fontSize: '13px', fontFamily: 'inherit', resize: 'none', boxSizing: 'border-box' }}></textarea>
              
              {/* Checkbox RGPD */}
              <label style={{ display: 'flex', alignItems: 'start', gap: '8px', marginBottom: '12px', cursor: 'pointer' }}>
                <input type="checkbox" required style={{ marginTop: '3px', cursor: 'pointer', accentColor: '#10b981' }} />
                <span style={{ fontSize: '10px', color: '#94a3b8', lineHeight: '1.4' }}>
                  Acepto la <a href="#" onClick={(e) => { e.preventDefault(); setPrivacidadOpen(true); }} style={{ color: '#10b981', textDecoration: 'underline', cursor: 'pointer' }}>política de privacidad</a> y el tratamiento de mis datos para recibir información.
                </span>
              </label>
              
              <button type="submit" className="btn btn-primary" style={{ width: '100%', fontSize: '13px', padding: '12px' }}>📧 Enviar Consulta</button>
            </form>
          </div>
        </div>
      </section>



      {/* PANEL ADMIN COMO OVERLAY/MODAL */}
      {currentUser && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)', zIndex: 1000, overflowY: 'auto', overflowX: 'hidden', width: '100vw', maxWidth: '100vw' }}>
          <div style={{ padding: '16px', width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
            {/* Header con botón cerrar */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '12px' }}>
              <h2 style={{ fontSize: '20px', color: 'white', fontFamily: "'Playfair Display', serif", margin: 0 }}>Panel Admin</h2>
              <button onClick={handleLogout} style={{ padding: '8px 16px', background: '#dc2626', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '12px', whiteSpace: 'nowrap' }}>
                ✕ Cerrar
              </button>
            </div>

            {/* TABS - Grid responsive */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', gap: '8px', marginBottom: '20px' }}>
              <button onClick={() => setAdminTab('proyectos')} style={{ padding: '10px 12px', background: adminTab === 'proyectos' ? 'linear-gradient(135deg, #10b981, #059669)' : 'rgba(51, 65, 85, 0.4)', color: 'white', border: adminTab === 'proyectos' ? 'none' : '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', transition: 'all 0.3s', fontSize: '11px', textAlign: 'center' }}>
                📁 Proyectos
              </button>
              <button onClick={() => setAdminTab('contacto')} style={{ padding: '10px 12px', background: adminTab === 'contacto' ? 'linear-gradient(135deg, #10b981, #059669)' : 'rgba(51, 65, 85, 0.4)', color: 'white', border: adminTab === 'contacto' ? 'none' : '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', transition: 'all 0.3s', fontSize: '11px', textAlign: 'center' }}>
                📞 Contacto
              </button>
              <button onClick={() => setAdminTab('javier')} style={{ padding: '10px 12px', background: adminTab === 'javier' ? 'linear-gradient(135deg, #10b981, #059669)' : 'rgba(51, 65, 85, 0.4)', color: 'white', border: adminTab === 'javier' ? 'none' : '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', transition: 'all 0.3s', fontSize: '11px', textAlign: 'center' }}>
                👤 Javier
              </button>
              <button onClick={() => setAdminTab('testimonios')} style={{ padding: '10px 12px', background: adminTab === 'testimonios' ? 'linear-gradient(135deg, #10b981, #059669)' : 'rgba(51, 65, 85, 0.4)', color: 'white', border: adminTab === 'testimonios' ? 'none' : '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', transition: 'all 0.3s', fontSize: '11px', textAlign: 'center' }}>
                ⭐ Reseñas
              </button>
              <button onClick={() => setAdminTab('faq')} style={{ padding: '10px 12px', background: adminTab === 'faq' ? 'linear-gradient(135deg, #10b981, #059669)' : 'rgba(51, 65, 85, 0.4)', color: 'white', border: adminTab === 'faq' ? 'none' : '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', transition: 'all 0.3s', fontSize: '11px', textAlign: 'center' }}>
                ❓ FAQ
              </button>
            </div>

            {/* TAB: PROYECTOS */}
            {adminTab === 'proyectos' && (
              <div>
                <h3 style={{ fontSize: '18px', color: 'white', marginBottom: '24px' }}>Gestionar Proyectos</h3>
                
                <div style={{ background: 'linear-gradient(135deg, rgba(51,65,85,0.4), rgba(30,41,59,0.3))', border: '1px solid rgba(16, 185, 129, 0.3)', borderRadius: '12px', padding: '24px', marginBottom: '32px' }}>
                  <h4 style={{ color: 'white', marginBottom: '12px', fontSize: '15px' }}>
                    {editingProject ? '✏️ Editar Proyecto' : '➕ Agregar Nuevo Proyecto'}
                  </h4>
                  <div style={{ display: 'grid', gap: '16px' }}>
                    <input 
                      type="text" 
                      placeholder="Título del proyecto" 
                      value={newProject.titulo}
                      onChange={(e) => setNewProject({...newProject, titulo: e.target.value})}
                      style={{ padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white' }}
                    />
                    <input 
                      type="text" 
                      placeholder="Ubicación/Población" 
                      value={newProject.ubicacion}
                      onChange={(e) => setNewProject({...newProject, ubicacion: e.target.value})}
                      style={{ padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white' }}
                    />
                    <select 
                      value={newProject.categoria}
                      onChange={(e) => setNewProject({...newProject, categoria: e.target.value})}
                      style={{ padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', width: '100%', boxSizing: 'border-box' }}
                    >
                      <option value="Reformas de Baños">Reformas de Baños</option>
                      <option value="Reformas de Cocinas">Reformas de Cocinas</option>
                      <option value="Reformas Integrales">Reformas Integrales</option>
                      <option value="Construcción">Construcción</option>
                      <option value="Mantenimiento">Mantenimiento</option>
                    </select>
                    <textarea id="descripción_del_proyecto" name="descripción_del_proyecto" placeholder="Descripción del proyecto" 
                      value={newProject.descripcion}
                      onChange={(e) => setNewProject({...newProject, descripcion: e.target.value})}
                      rows="4"
                      style={{ padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', fontFamily: 'Inter', width: '100%', boxSizing: 'border-box' }}
                    />
                    
                    {/* Link Instagram/Video */}
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '12px', marginBottom: '6px', fontWeight: '600' }}>📷 Link Instagram/Video (opcional)</label>
                      <input 
                        type="url" 
                        placeholder="https://www.instagram.com/p/ABC123/ o https://www.instagram.com/reel/XYZ/" 
                        value={newProject.instagram_url}
                        onChange={(e) => setNewProject({...newProject, instagram_url: e.target.value})}
                        style={{ padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', width: '100%', boxSizing: 'border-box', fontSize: '12px' }}
                      />
                      <p style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px' }}>Si agregas un link de Instagram, se mostrará el video/reel en lugar de fotos</p>
                    </div>
                    
                    {/* Upload Imagen Antes */}
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '12px', marginBottom: '6px', fontWeight: '600' }}>Foto ANTES</label>
                      {previewAntes && (
                        <div style={{ marginBottom: '8px', textAlign: 'center' }}>
                          <img src={previewAntes} alt="Antes" style={{ maxWidth: '100%', maxHeight: '150px', borderRadius: '6px' }} />
                        </div>
                      )}
                      <label htmlFor="file_input_antes" style={{ display: 'block', padding: '12px', background: 'rgba(16, 185, 129, 0.1)', border: '2px dashed rgba(16, 185, 129, 0.5)', borderRadius: '6px', cursor: 'pointer', textAlign: 'center', color: '#10b981', fontWeight: '600', fontSize: '11px' }}>
                        📷 Subir Foto Antes
                        <input id="file_input_antes" type="file" accept="image/*" onChange={handleImagenAntes} style={{ display: 'none' }} />
                      </label>
                    </div>

                    {/* Upload Imagen Después */}
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '12px', marginBottom: '6px', fontWeight: '600' }}>Foto DESPUÉS</label>
                      {previewDespues && (
                        <div style={{ marginBottom: '8px', textAlign: 'center' }}>
                          <img src={previewDespues} alt="Después" style={{ maxWidth: '100%', maxHeight: '150px', borderRadius: '6px' }} />
                        </div>
                      )}
                      <label htmlFor="file_input_despues" style={{ display: 'block', padding: '12px', background: 'rgba(16, 185, 129, 0.1)', border: '2px dashed rgba(16, 185, 129, 0.5)', borderRadius: '6px', cursor: 'pointer', textAlign: 'center', color: '#10b981', fontWeight: '600', fontSize: '11px' }}>
                        📷 Subir Foto Después
                        <input id="file_input_despues" type="file" accept="image/*" onChange={handleImagenDespues} style={{ display: 'none' }} />
                      </label>
                    </div>
                    
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button 
                        onClick={editingProject ? saveEditProject : addProject}
                        style={{ flex: 1, padding: '10px 20px', background: 'linear-gradient(135deg, #10b981, #059669)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}
                      >
                        {editingProject ? '✓ Guardar Cambios' : '✓ Agregar Proyecto'}
                      </button>
                      {editingProject && (
                        <button 
                          onClick={cancelEdit}
                          style={{ padding: '10px 20px', background: 'rgba(107, 114, 128, 0.3)', color: '#94a3b8', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}
                        >
                          Cancelar
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                <h4 style={{ color: 'white', marginBottom: '12px', fontSize: '15px' }}>📋 Proyectos Existentes ({trabajos.length})</h4>
                {trabajos.length > 0 ? (
                  <div style={{ display: 'grid', gap: '16px' }}>
                    {trabajos.map(p => (
                      <div key={p.id} style={{ background: 'linear-gradient(135deg, rgba(51,65,85,0.4), rgba(30,41,59,0.3))', border: '1px solid rgba(148, 163, 184, 0.2)', borderRadius: '8px', padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <p style={{ color: 'white', fontWeight: '600', marginBottom: '4px' }}>{p.titulo}</p>
                          <p style={{ color: '#94a3b8', fontSize: '14px' }}>📍 {p.ubicacion || 'Sin ubicación'}</p>
                          <p style={{ color: '#cbd5e1', fontSize: '13px', marginTop: '4px' }}>{p.descripcion.substring(0, 60)}...</p>
                        </div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <button onClick={() => startEditProject(p)} style={{ padding: '8px 16px', background: 'rgba(59, 130, 246, 0.2)', color: '#60a5fa', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
                            Editar
                          </button>
                          <button onClick={() => deleteProject(p.id)} style={{ padding: '8px 16px', background: 'rgba(239, 68, 68, 0.2)', color: '#f87171', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
                            Eliminar
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{ color: '#94a3b8', textAlign: 'center', padding: '32px', background: 'rgba(51, 65, 85, 0.2)', borderRadius: '8px' }}>No hay proyectos aún. ¡Crea uno!</p>
                )}
              </div>
            )}

            {/* TAB: DATOS DE CONTACTO */}
            {adminTab === 'contacto' && (
              <div>
                <h3 style={{ fontSize: '18px', color: 'white', marginBottom: '24px' }}>Datos de Contacto</h3>
                <div style={{ background: 'linear-gradient(135deg, rgba(51,65,85,0.4), rgba(30,41,59,0.3))', border: '1px solid rgba(16, 185, 129, 0.3)', borderRadius: '12px', padding: '24px', maxWidth: '100%' }}>
                  <div style={{ display: 'grid', gap: '16px' }}>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '13px', marginBottom: '6px', fontWeight: '600' }}>Nombre Completo</label>
                      <input 
                        type="text" 
                        value={adminData.nombre_completo}
                        onChange={(e) => setAdminData({...adminData, nombre_completo: e.target.value})}
                        style={{ width: '100%', padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', boxSizing: 'border-box' }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '13px', marginBottom: '6px', fontWeight: '600' }}>Teléfono</label>
                      <input 
                        type="tel" 
                        value={adminData.telefono}
                        onChange={(e) => setAdminData({...adminData, telefono: e.target.value})}
                        style={{ width: '100%', padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', boxSizing: 'border-box' }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '13px', marginBottom: '6px', fontWeight: '600' }}>Ciudad</label>
                      <input 
                        type="text" 
                        value={adminData.ciudad}
                        onChange={(e) => setAdminData({...adminData, ciudad: e.target.value})}
                        style={{ width: '100%', padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', boxSizing: 'border-box' }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '13px', marginBottom: '6px', fontWeight: '600' }}>Email de Contacto</label>
                      <input 
                        type="email" 
                        value={adminData.email_contacto}
                        onChange={(e) => setAdminData({...adminData, email_contacto: e.target.value})}
                        style={{ width: '100%', padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', boxSizing: 'border-box' }}
                      />
                    </div>
                    <button 
                      onClick={updateAdminData}
                      style={{ padding: '12px 24px', background: 'linear-gradient(135deg, #10b981, #059669)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}
                    >
                      ✓ Guardar Cambios
                    </button>
                  </div>
                </div>

                {/* Textos del Hero */}
                <h3 style={{ fontSize: '18px', color: 'white', marginTop: '32px', marginBottom: '16px' }}>📝 Textos de Inicio (Hero)</h3>
                <div style={{ background: 'linear-gradient(135deg, rgba(51,65,85,0.4), rgba(30,41,59,0.3))', border: '1px solid rgba(16, 185, 129, 0.3)', borderRadius: '12px', padding: '20px', marginBottom: '24px' }}>
                  <p style={{ fontSize: '11px', color: '#94a3b8', marginBottom: '12px', padding: '8px', background: 'rgba(59, 130, 246, 0.1)', borderRadius: '6px', borderLeft: '3px solid #3b82f6' }}>
                    💡 <strong>Tip:</strong> Usa asteriscos (*) para destacar palabras en verde. Ejemplo: "Reformas en *Calafell*"
                  </p>
                  <div style={{ display: 'grid', gap: '14px' }}>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '12px', marginBottom: '6px', fontWeight: '600' }}>Título Principal</label>
                      <input 
                        type="text" 
                        value={heroTextos.titulo}
                        onChange={(e) => setHeroTextos({...heroTextos, titulo: e.target.value})}
                        placeholder="Ej: Reformas en *Calafell*"
                        style={{ width: '100%', padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', boxSizing: 'border-box' }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '12px', marginBottom: '6px', fontWeight: '600' }}>Subtítulo</label>
                      <textarea 
                        value={heroTextos.subtitulo}
                        onChange={(e) => setHeroTextos({...heroTextos, subtitulo: e.target.value})}
                        rows="2"
                        placeholder="Descripción breve de tus servicios"
                        style={{ width: '100%', padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box' }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '12px', marginBottom: '6px', fontWeight: '600' }}>Texto Botón Principal</label>
                      <input 
                        type="text" 
                        value={heroTextos.cta_texto}
                        onChange={(e) => setHeroTextos({...heroTextos, cta_texto: e.target.value})}
                        placeholder="Ej: 📞 Presupuesto Gratis 24h"
                        style={{ width: '100%', padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', boxSizing: 'border-box' }}
                      />
                    </div>
                  </div>
                </div>

                {/* Pruebas Sociales */}
                <h3 style={{ fontSize: '18px', color: 'white', marginTop: '32px', marginBottom: '16px' }}>Pruebas Sociales</h3>
                <div style={{ background: 'linear-gradient(135deg, rgba(51,65,85,0.4), rgba(30,41,59,0.3))', border: '1px solid rgba(16, 185, 129, 0.3)', borderRadius: '12px', padding: '20px', maxWidth: '100%' }}>
                  <div style={{ display: 'grid', gap: '14px' }}>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '12px', marginBottom: '6px', fontWeight: '600' }}>Años de Experiencia</label>
                      <input 
                        type="number" 
                        value={pruebasSociales.anos_experiencia}
                        onChange={(e) => setPruebasSociales({...pruebasSociales, anos_experiencia: parseInt(e.target.value)})}
                        style={{ width: '100%', padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', boxSizing: 'border-box' }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '12px', marginBottom: '6px', fontWeight: '600' }}>Número de Reformas Realizadas</label>
                      <input 
                        type="number" 
                        value={pruebasSociales.num_reformas}
                        onChange={(e) => setPruebasSociales({...pruebasSociales, num_reformas: parseInt(e.target.value)})}
                        style={{ width: '100%', padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', boxSizing: 'border-box' }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '12px', marginBottom: '6px', fontWeight: '600' }}>Valoración (0-5)</label>
                      <input 
                        type="number" 
                        step="0.1"
                        min="0"
                        max="5"
                        value={pruebasSociales.valoracion}
                        onChange={(e) => setPruebasSociales({...pruebasSociales, valoracion: parseFloat(e.target.value)})}
                        style={{ width: '100%', padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', boxSizing: 'border-box' }}
                      />
                    </div>
                    <button 
                      onClick={updateAdminData}
                      style={{ padding: '12px 24px', background: 'linear-gradient(135deg, #10b981, #059669)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}
                    >
                      ✓ Guardar Cambios
                    </button>
                  </div>
                </div>
                {/* Cambiar Contraseña */}
                <h3 style={{ fontSize: '18px', color: 'white', marginTop: '32px', marginBottom: '16px' }}>🔒 Cambiar Contraseña</h3>
                <div style={{ background: 'linear-gradient(135deg, rgba(51,65,85,0.4), rgba(30,41,59,0.3))', border: '1px solid rgba(16, 185, 129, 0.3)', borderRadius: '12px', padding: '20px', maxWidth: '100%' }}>
                  <div style={{ display: 'grid', gap: '14px' }}>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '12px', marginBottom: '6px', fontWeight: '600' }}>Nueva Contraseña</label>
                      <input 
                        type="password" 
                        name="nueva_password"
                        value={nuevaPassword}
                        onChange={(e) => setNuevaPassword(e.target.value)}
                        placeholder="Mínimo 8 caracteres"
                        autoComplete="new-password"
                        style={{ width: '100%', padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', boxSizing: 'border-box' }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '12px', marginBottom: '6px', fontWeight: '600' }}>Confirmar Contraseña</label>
                      <input 
                        type="password" 
                        name="confirmar_password"
                        value={confirmarPassword}
                        onChange={(e) => setConfirmarPassword(e.target.value)}
                        placeholder="Repite la contraseña"
                        autoComplete="new-password"
                        style={{ width: '100%', padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', boxSizing: 'border-box' }}
                      />
                    </div>
                    <button 
                      onClick={cambiarPassword}
                      style={{ padding: '12px 24px', background: 'linear-gradient(135deg, #3b82f6, #2563eb)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}
                    >
                      🔑 Cambiar Contraseña
                    </button>
                  </div>
                </div>

              </div>
            )}

            {/* TAB: SOBRE JAVIER */}
            {adminTab === 'javier' && (
              <div>
                <h3 style={{ fontSize: '18px', color: 'white', marginBottom: '24px' }}>Información de Javier</h3>
                <div style={{ background: 'linear-gradient(135deg, rgba(51,65,85,0.4), rgba(30,41,59,0.3))', border: '1px solid rgba(16, 185, 129, 0.3)', borderRadius: '12px', padding: '24px' }}>
                  <div style={{ display: 'grid', gap: '16px' }}>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '13px', marginBottom: '6px', fontWeight: '600' }}>Años de Experiencia</label>
                      <input 
                        type="number" 
                        value={javierData.experiencia}
                        onChange={(e) => setJavierData({...javierData, experiencia: parseInt(e.target.value)})}
                        style={{ width: '100%', padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', boxSizing: 'border-box' }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '13px', marginBottom: '6px', fontWeight: '600' }}>Biografía</label>
                      <textarea 
                        value={javierData.biografia}
                        onChange={(e) => setJavierData({...javierData, biografia: e.target.value})}
                        rows="6"
                        style={{ width: '100%', padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', boxSizing: 'border-box', fontFamily: 'Inter' }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', color: '#cbd5e1', fontSize: '13px', marginBottom: '6px', fontWeight: '600' }}>Foto de Javier</label>
                      {javierData.foto && (
                        <div style={{ marginBottom: '12px', textAlign: 'center' }}>
                          <img src={javierData.foto} alt="Javier" style={{ maxWidth: '200px', maxHeight: '200px', borderRadius: '8px' }} />
                          <button 
                            onClick={borrarFotoJavier}
                            style={{ display: 'block', marginTop: '8px', padding: '8px 16px', background: '#dc2626', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}
                          >
                            🗑️ Borrar Foto
                          </button>
                        </div>
                      )}
                      <label htmlFor="file_input_javier" style={{ display: 'block', padding: '16px', background: 'rgba(16, 185, 129, 0.1)', border: '2px dashed rgba(16, 185, 129, 0.5)', borderRadius: '8px', cursor: 'pointer', textAlign: 'center', color: '#10b981', fontWeight: '600' }}>
                        📷 Subir Foto
                        <input id="file_input_javier" type="file" accept="image/*" onChange={handleFotoJavier} style={{ display: 'none' }} />
                      </label>
                    </div>
                    <button 
                      onClick={guardarInfoJavier}
                      style={{ padding: '12px 24px', background: 'linear-gradient(135deg, #10b981, #059669)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}
                    >
                      ✓ Guardar Información
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* TAB: TESTIMONIOS */}
            {adminTab === 'testimonios' && (
              <div>
                <h3 style={{ fontSize: '18px', color: 'white', marginBottom: '24px' }}>Gestionar Testimonios</h3>
                
                {/* NUEVO TESTIMONIO */}
                <div style={{ background: 'linear-gradient(135deg, rgba(51,65,85,0.4), rgba(30,41,59,0.3))', border: '1px solid rgba(16, 185, 129, 0.3)', borderRadius: '12px', padding: '24px', marginBottom: '32px' }}>
                  <h4 style={{ color: 'white', marginBottom: '12px', fontSize: '15px' }}>➕ Nuevo Testimonio</h4>
                  <div style={{ display: 'grid', gap: '16px' }}>
                    <input 
                      type="text" 
                      placeholder="Nombre del cliente" 
                      value={nuevoTestimonio.nombre}
                      onChange={(e) => setNuevoTestimonio({...nuevoTestimonio, nombre: e.target.value})}
                      style={{ padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white' }}
                    />
                    <input 
                      type="email" 
                      placeholder="Email del cliente" 
                      value={nuevoTestimonio.email}
                      onChange={(e) => setNuevoTestimonio({...nuevoTestimonio, email: e.target.value})}
                      style={{ padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white' }}
                    />
                    <textarea id="testimonio_(máx_300_caracteres)" name="testimonio_(máx_300_caracteres)" placeholder="Testimonio (máx 300 caracteres)" 
                      value={nuevoTestimonio.contenido}
                      onChange={(e) => {
                        if (e.target.value.length <= 300) {
                          setNuevoTestimonio({...nuevoTestimonio, contenido: e.target.value});
                        }
                      }}
                      rows="4"
                      style={{ padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', fontFamily: 'Inter' }}
                    />
                    <p style={{ color: '#94a3b8', fontSize: '12px' }}>{nuevoTestimonio.contenido.length}/300 caracteres</p>
                    <button 
                      onClick={agregarTestimonio}
                      style={{ padding: '12px 24px', background: 'linear-gradient(135deg, #10b981, #059669)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}
                    >
                      ✓ Agregar Testimonio
                    </button>
                  </div>
                </div>

                                {/* TESTIMONIOS PENDIENTES */}
                <h4 style={{ color: 'white', marginBottom: '12px', fontSize: '15px' }}>⏳ Pendientes ({testimonios.filter(t => t.estado === 'pendiente' || (!t.estado && !t.aprobado)).length})</h4>
                {testimonios.filter(t => t.estado === 'pendiente' || (!t.estado && !t.aprobado)).length > 0 ? (
                  <div style={{ display: 'grid', gap: '12px', marginBottom: '24px' }}>
                    {testimonios.filter(t => t.estado === 'pendiente' || (!t.estado && !t.aprobado)).map(t => (
                      <div key={t.id} style={{ background: 'rgba(251, 191, 36, 0.1)', border: '1px solid rgba(251, 191, 36, 0.3)', borderRadius: '8px', padding: '14px' }}>
                        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
                          {[1, 2, 3, 4, 5].map(star => (
                            <span key={star} style={{ color: star <= (t.valoracion || 5) ? '#fbbf24' : '#4b5563', fontSize: '14px' }}>★</span>
                          ))}
                        </div>
                        <p style={{ color: '#fbbf24', fontWeight: '600', fontSize: '13px', marginBottom: '4px' }}>{t.nombre_cliente || t.nombre}</p>
                        <p style={{ color: '#cbd5e1', fontSize: '12px', marginBottom: '8px' }}>{t.contenido}</p>
                        <p style={{ color: '#94a3b8', fontSize: '10px', marginBottom: '10px' }}>📅 {new Date(t.created_at).toLocaleDateString('es-ES')}</p>
                        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                          <button 
                            onClick={() => aprobarTestimonio(t.id)}
                            style={{ padding: '6px 12px', background: 'rgba(34, 197, 94, 0.2)', color: '#22c55e', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}
                          >
                            ✓ Aprobar
                          </button>
                          <button 
                            onClick={() => rechazarTestimonio(t.id)}
                            style={{ padding: '6px 12px', background: 'rgba(239, 68, 68, 0.2)', color: '#ef4444', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}
                          >
                            ✕ Rechazar
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{ color: '#94a3b8', textAlign: 'center', padding: '12px', background: 'rgba(51, 65, 85, 0.2)', borderRadius: '8px', fontSize: '12px', marginBottom: '24px' }}>No hay testimonios pendientes</p>
                )}

                {/* TESTIMONIOS APROBADOS */}
                <h4 style={{ color: 'white', marginBottom: '12px', fontSize: '15px' }}>✅ Aprobados ({testimonios.filter(t => t.aprobado || t.estado === 'aprobado').length})</h4>
                {testimonios.filter(t => t.aprobado || t.estado === 'aprobado').length > 0 ? (
                  <div style={{ display: 'grid', gap: '12px', marginBottom: '24px' }}>
                    {testimonios.filter(t => t.aprobado || t.estado === 'aprobado').map(t => (
                      <div key={t.id} style={{ background: 'rgba(34, 197, 94, 0.1)', border: '1px solid rgba(34, 197, 94, 0.3)', borderRadius: '8px', padding: '14px' }}>
                        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
                          {[1, 2, 3, 4, 5].map(star => (
                            <span key={star} style={{ color: star <= (t.valoracion || 5) ? '#fbbf24' : '#4b5563', fontSize: '14px' }}>★</span>
                          ))}
                        </div>
                        <p style={{ color: '#22c55e', fontWeight: '600', fontSize: '13px', marginBottom: '4px' }}>{t.nombre_cliente || t.nombre}</p>
                        <p style={{ color: '#cbd5e1', fontSize: '12px', marginBottom: '8px' }}>{t.contenido}</p>
                        <p style={{ color: '#94a3b8', fontSize: '10px', marginBottom: '10px' }}>📅 {new Date(t.created_at).toLocaleDateString('es-ES')}</p>
                        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                          <button 
                            onClick={() => desaprobarTestimonio(t.id)}
                            style={{ padding: '6px 12px', background: 'rgba(107, 114, 128, 0.2)', color: '#94a3b8', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}
                          >
                            ↩️ Desaprobar
                          </button>
                          <button 
                            onClick={() => eliminarTestimonioDefinitivo(t.id)}
                            style={{ padding: '6px 12px', background: 'rgba(239, 68, 68, 0.2)', color: '#ef4444', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}
                          >
                            🗑️ Eliminar
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{ color: '#94a3b8', textAlign: 'center', padding: '12px', background: 'rgba(51, 65, 85, 0.2)', borderRadius: '8px', fontSize: '12px', marginBottom: '24px' }}>No hay testimonios aprobados</p>
                )}

                {/* TESTIMONIOS RECHAZADOS */}
                <h4 style={{ color: 'white', marginBottom: '12px', fontSize: '15px' }}>❌ Rechazados ({testimonios.filter(t => t.estado === 'rechazado').length})</h4>
                {testimonios.filter(t => t.estado === 'rechazado').length > 0 ? (
                  <div style={{ display: 'grid', gap: '12px' }}>
                    {testimonios.filter(t => t.estado === 'rechazado').map(t => (
                      <div key={t.id} style={{ background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.3)', borderRadius: '8px', padding: '14px' }}>
                        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
                          {[1, 2, 3, 4, 5].map(star => (
                            <span key={star} style={{ color: star <= (t.valoracion || 5) ? '#fbbf24' : '#4b5563', fontSize: '14px' }}>★</span>
                          ))}
                        </div>
                        <p style={{ color: '#ef4444', fontWeight: '600', fontSize: '13px', marginBottom: '4px' }}>{t.nombre_cliente || t.nombre}</p>
                        <p style={{ color: '#cbd5e1', fontSize: '12px', marginBottom: '8px' }}>{t.contenido}</p>
                        <p style={{ color: '#94a3b8', fontSize: '10px', marginBottom: '10px' }}>📅 {new Date(t.created_at).toLocaleDateString('es-ES')}</p>
                        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                          <button 
                            onClick={() => aprobarTestimonio(t.id)}
                            style={{ padding: '6px 12px', background: 'rgba(34, 197, 94, 0.2)', color: '#22c55e', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}
                          >
                            ✓ Aprobar
                          </button>
                          <button 
                            onClick={() => eliminarTestimonioDefinitivo(t.id)}
                            style={{ padding: '6px 12px', background: 'rgba(239, 68, 68, 0.2)', color: '#ef4444', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}
                          >
                            🗑️ Eliminar
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{ color: '#94a3b8', textAlign: 'center', padding: '12px', background: 'rgba(51, 65, 85, 0.2)', borderRadius: '8px', fontSize: '12px' }}>No hay testimonios rechazados</p>
                )}

              </div>
            )}

            {/* TAB: FAQ */}
            {adminTab === 'faq' && (
              <div>
                <h3 style={{ fontSize: '18px', color: 'white', marginBottom: '24px' }}>Gestionar Preguntas Frecuentes</h3>
                
                {/* Agregar nueva FAQ */}
                <div style={{ background: 'linear-gradient(135deg, rgba(51,65,85,0.4), rgba(30,41,59,0.3))', border: '1px solid rgba(16, 185, 129, 0.3)', borderRadius: '12px', padding: '20px', marginBottom: '24px' }}>
                  <h4 style={{ color: 'white', marginBottom: '12px', fontSize: '15px' }}>
                    {editingFaq ? '✏️ Editar Pregunta' : '➕ Agregar Pregunta'}
                  </h4>
                  <div style={{ display: 'grid', gap: '12px' }}>
                    <input 
                      type="text" 
                      placeholder="Pregunta" 
                      value={nuevaFaq.pregunta}
                      onChange={(e) => setNuevaFaq({...nuevaFaq, pregunta: e.target.value})}
                      style={{ padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', width: '100%', boxSizing: 'border-box' }}
                    />
                    <textarea 
                      placeholder="Respuesta" 
                      value={nuevaFaq.respuesta}
                      onChange={(e) => setNuevaFaq({...nuevaFaq, respuesta: e.target.value})}
                      rows="3"
                      style={{ padding: '10px', background: 'rgba(71, 85, 105, 0.5)', border: '1px solid rgba(148, 163, 184, 0.3)', borderRadius: '8px', color: 'white', fontFamily: 'Inter', width: '100%', boxSizing: 'border-box' }}
                    />
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button 
                        onClick={editingFaq ? saveEditFaq : agregarFaq}
                        style={{ flex: 1, padding: '10px 20px', background: 'linear-gradient(135deg, #10b981, #059669)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}
                      >
                        {editingFaq ? '✓ Guardar Cambios' : '✓ Agregar FAQ'}
                      </button>
                      {editingFaq && (
                        <button 
                          onClick={cancelEditFaq}
                          style={{ padding: '10px 20px', background: 'rgba(107, 114, 128, 0.3)', color: '#94a3b8', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}
                        >
                          Cancelar
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Lista de FAQs */}
                <h4 style={{ color: 'white', marginBottom: '12px', fontSize: '15px' }}>📋 Preguntas ({faqs.length})</h4>
                {faqs.length > 0 ? (
                  <div style={{ display: 'grid', gap: '12px' }}>
                    {faqs.map(f => (
                      <div key={f.id} style={{ background: 'linear-gradient(135deg, rgba(51,65,85,0.4), rgba(30,41,59,0.3))', border: '1px solid rgba(148, 163, 184, 0.2)', borderRadius: '8px', padding: '14px' }}>
                        <div style={{ marginBottom: '8px' }}>
                          <p style={{ color: 'white', fontWeight: '600', marginBottom: '4px', fontSize: '13px' }}>{f.pregunta}</p>
                          <p style={{ color: '#cbd5e1', fontSize: '12px' }}>{f.respuesta}</p>
                        </div>
                        <div style={{ display: 'flex', gap: '8px', marginTop: '10px', flexWrap: 'wrap' }}>
                          <button 
                            onClick={() => startEditFaq(f)}
                            style={{ padding: '6px 12px', background: 'rgba(59, 130, 246, 0.2)', color: '#60a5fa', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}
                          >
                            ✏️ Editar
                          </button>
                          <button 
                            onClick={() => toggleVisibleFaq(f.id, f.visible)}
                            style={{ padding: '6px 12px', background: f.visible ? 'rgba(34, 197, 94, 0.2)' : 'rgba(107, 114, 128, 0.2)', color: f.visible ? '#22c55e' : '#94a3b8', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}
                          >
                            {f.visible ? '👁️ Visible' : '🙈 Oculta'}
                          </button>
                          <button 
                            onClick={() => eliminarFaq(f.id)}
                            style={{ padding: '6px 12px', background: 'rgba(239, 68, 68, 0.2)', color: '#f87171', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}
                          >
                            🗑️ Eliminar
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{ color: '#94a3b8', textAlign: 'center', padding: '24px', background: 'rgba(51, 65, 85, 0.2)', borderRadius: '8px' }}>No hay FAQs. ¡Crea una!</p>
                )}
              </div>
            )}


          </div>
        </div>
      )}

      {/* Botón admin eliminado - usar doble click en logo JR */}

      <div id="loginModal" className="modal">
        <div className="modal-content">
          <h2>Admin</h2>
          <form onSubmit={handleLogin}>
            <input 
              type="text" 
              placeholder="Usuario o Email" 
              value={adminEmail} 
              onChange={(e) => setAdminEmail(e.target.value)} 
              required 
              autoCapitalize="none"
              autoCorrect="off"
              autoComplete="email"
              style={{ marginBottom: '12px' }} 
            />
            <div style={{ position: 'relative', marginBottom: '24px' }}>
              <input 
                type={mostrarPassword ? "text" : "password"}
                placeholder="Contraseña" 
                value={adminPass} 
                onChange={(e) => setAdminPass(e.target.value)} 
                required 
                autoCapitalize="none"
                autoCorrect="off"
                autoComplete="current-password"
                style={{ width: '100%', paddingRight: '40px' }} 
              />
              <button
                type="button"
                onClick={() => setMostrarPassword(!mostrarPassword)}
                style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', fontSize: '18px', padding: '4px' }}
              >
                {mostrarPassword ? '🙈' : '👁️'}
              </button>
            </div>
            {loginError && <p className="error">{loginError}</p>}
            <button type="submit" className="btn btn-primary" style={{ width: '100%', marginBottom: '12px' }}>Entrar</button>
            <button type="button" className="btn btn-secondary" style={{ width: '100%' }} onClick={() => document.getElementById('loginModal').classList.remove('active')}>Cancelar</button>
          </form>
          {currentUser && (
            <button onClick={handleLogout} style={{ width: '100%', marginTop: '12px', padding: '10px', background: '#dc2626', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
              Cerrar sesión
            </button>
          )}
        </div>
      </div>

      {/* Contenedor de notificaciones toast */}
      <div className="toast-container">
        {notifications.map(notif => (
          <div key={notif.id} className={`toast toast-${notif.type}`}>
            <span style={{ fontSize: '18px' }}>
              {notif.type === 'success' && '✓'}
              {notif.type === 'error' && '✕'}
              {notif.type === 'info' && 'ℹ'}
            </span>
            <span>{notif.message}</span>
          </div>
        ))}
      </div>

      {/* Botón Volver Arriba */}
      {mostrarVolverArriba && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{
            position: 'fixed',
            bottom: '24px',
            right: '24px',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #10b981, #059669)',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            fontSize: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
            zIndex: 100,
            transition: 'transform 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
          onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
        >
          ↑
        </button>
      )}

      {/* Modal Política de Privacidad */}
      {privacidadOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0, 0, 0, 0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', overflowY: 'auto' }}>
          <div style={{ background: 'linear-gradient(135deg, rgba(15,23,42,0.98), rgba(30,41,59,0.95))', border: '1px solid rgba(16, 185, 129, 0.3)', borderRadius: '16px', padding: '32px 24px', maxWidth: '700px', width: '100%', maxHeight: '90vh', overflowY: 'auto', position: 'relative' }}>
            <button onClick={() => setPrivacidadOpen(false)} style={{ position: 'absolute', top: '16px', right: '16px', background: 'rgba(239, 68, 68, 0.2)', color: '#f87171', border: 'none', borderRadius: '50%', width: '32px', height: '32px', cursor: 'pointer', fontSize: '18px', fontWeight: 'bold' }}>✕</button>
            
            <h2 style={{ color: 'white', marginBottom: '24px', fontSize: '24px', fontFamily: "'Playfair Display', serif" }}>Política de Privacidad</h2>
            
            <div style={{ color: '#cbd5e1', fontSize: '13px', lineHeight: '1.7' }}>
              <p style={{ marginBottom: '16px' }}><strong style={{ color: 'white' }}>Última actualización:</strong> Abril 2026</p>
              
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>1. Responsable del tratamiento</h3>
              <p style={{ marginBottom: '12px' }}>
                <strong>Identidad:</strong> Javier García Pina (JAVIREPARA)<br/>
                <strong>Dirección:</strong> Calafell, Tarragona<br/>
                <strong>Email:</strong> javirepara79@gmail.com<br/>
                <strong>Teléfono:</strong> +34 635 36 79 78
              </p>
              
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>2. Datos que recogemos</h3>
              <p style={{ marginBottom: '12px' }}>Recogemos los siguientes datos personales cuando utilizas nuestros formularios:</p>
              <ul style={{ marginLeft: '20px', marginBottom: '12px' }}>
                <li>Nombre completo</li>
                <li>Email</li>
                <li>Teléfono (opcional)</li>
                <li>Mensaje o consulta</li>
              </ul>
              
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>3. Finalidad del tratamiento</h3>
              <p style={{ marginBottom: '12px' }}>Utilizamos tus datos para:</p>
              <ul style={{ marginLeft: '20px', marginBottom: '12px' }}>
                <li>Responder a tus consultas y solicitudes de presupuesto</li>
                <li>Gestionar la prestación de nuestros servicios</li>
                <li>Publicar testimonios (solo si das consentimiento expreso)</li>
              </ul>
              
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>4. Base legal</h3>
              <p style={{ marginBottom: '12px' }}>El tratamiento de tus datos se basa en tu consentimiento explícito al marcar la casilla de aceptación en nuestros formularios.</p>
              
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>5. Conservación de datos</h3>
              <p style={{ marginBottom: '12px' }}>Conservamos tus datos mientras sean necesarios para la finalidad que motivó su recogida, o mientras exista una obligación legal de conservarlos.</p>
              
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>6. Tus derechos</h3>
              <p style={{ marginBottom: '12px' }}>Tienes derecho a:</p>
              <ul style={{ marginLeft: '20px', marginBottom: '12px' }}>
                <li><strong>Acceso:</strong> Conocer qué datos tenemos sobre ti</li>
                <li><strong>Rectificación:</strong> Corregir datos incorrectos</li>
                <li><strong>Supresión:</strong> Eliminar tus datos</li>
                <li><strong>Oposición:</strong> Oponerte al tratamiento</li>
                <li><strong>Portabilidad:</strong> Recibir tus datos en formato estándar</li>
              </ul>
              <p style={{ marginBottom: '12px' }}>Para ejercer estos derechos, contacta con nosotros en javirepara79@gmail.com</p>
              
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>7. Seguridad</h3>
              <p style={{ marginBottom: '12px' }}>Implementamos medidas técnicas y organizativas apropiadas para proteger tus datos personales contra acceso no autorizado, pérdida o destrucción.</p>
              
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>8. Cookies</h3>
              <p style={{ marginBottom: '12px' }}>Esta web no utiliza cookies de terceros ni tracking. Solo cookies técnicas estrictamente necesarias para el funcionamiento del sitio.</p>
              
              <p style={{ marginTop: '24px', fontSize: '12px', color: '#94a3b8' }}>Si tienes dudas sobre esta política, contacta con nosotros en javirepara79@gmail.com</p>
            </div>
            
            <button onClick={() => setPrivacidadOpen(false)} style={{ marginTop: '24px', width: '100%', padding: '12px', background: 'linear-gradient(135deg, #10b981, #059669)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>Cerrar</button>
          </div>
        </div>
      )}


      {/* Modal Aviso Legal */}
      {avisoLegalOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0, 0, 0, 0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', overflowY: 'auto' }}>
          <div style={{ background: 'linear-gradient(135deg, rgba(15,23,42,0.98), rgba(30,41,59,0.95))', border: '1px solid rgba(16, 185, 129, 0.3)', borderRadius: '16px', padding: '32px 24px', maxWidth: '700px', width: '100%', maxHeight: '90vh', overflowY: 'auto', position: 'relative' }}>
            <button onClick={() => setAvisoLegalOpen(false)} style={{ position: 'absolute', top: '16px', right: '16px', background: 'rgba(239, 68, 68, 0.2)', color: '#f87171', border: 'none', borderRadius: '50%', width: '32px', height: '32px', cursor: 'pointer', fontSize: '18px', fontWeight: 'bold' }}>✕</button>
            
            <h2 style={{ color: 'white', marginBottom: '24px', fontSize: '24px', fontFamily: "'Playfair Display', serif" }}>Aviso Legal</h2>
            
            <div style={{ color: '#cbd5e1', fontSize: '13px', lineHeight: '1.7' }}>
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>1. Datos identificativos</h3>
              <p style={{ marginBottom: '12px' }}>
                En cumplimiento del artículo 10 de la Ley 34/2002, de Servicios de la Sociedad de la Información y Comercio Electrónico, se informa:<br/><br/>
                <strong>Titular:</strong> Javier García Pina<br/>
                <strong>NIF:</strong> 53086504C<br/>
                <strong>Nombre comercial:</strong> JAVIREPARA<br/>
                <strong>Domicilio:</strong> Carrer Mossèn Jaume Soler, 95, 43820 Calafell, Tarragona<br/>
                <strong>Email:</strong> javirepara79@gmail.com<br/>
                <strong>Teléfono:</strong> +34 635 36 79 78
              </p>
              
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>2. Objeto</h3>
              <p style={{ marginBottom: '12px' }}>
                El presente sitio web tiene por objeto proporcionar información sobre los servicios de reformas y construcción que ofrece JAVIREPARA, así como facilitar el contacto con clientes potenciales.
              </p>
              
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>3. Condiciones de uso</h3>
              <p style={{ marginBottom: '12px' }}>
                El acceso y uso de este sitio web atribuye la condición de usuario y supone la aceptación de estas condiciones. El usuario se compromete a hacer un uso adecuado de los contenidos y servicios que se ofrecen y a no emplearlos para actividades ilícitas.
              </p>
              
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>4. Propiedad intelectual</h3>
              <p style={{ marginBottom: '12px' }}>
                Todos los contenidos del sitio web (textos, fotografías, gráficos, imágenes, diseño, etc.) son propiedad de JAVIREPARA o se usan con autorización de sus propietarios. Queda prohibida su reproducción, distribución o modificación sin autorización expresa.
              </p>
              
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>5. Responsabilidad</h3>
              <p style={{ marginBottom: '12px' }}>
                JAVIREPARA se reserva el derecho a modificar cualquier tipo de información que pudiera aparecer en el sitio web, sin que exista obligación de preavisar o poner en conocimiento de los usuarios dichas modificaciones.
              </p>
              
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>6. Enlaces</h3>
              <p style={{ marginBottom: '12px' }}>
                Los enlaces a sitios web de terceros son solo informativos. JAVIREPARA no se hace responsable del contenido de dichos sitios ni de las condiciones de uso y políticas de privacidad de los mismos.
              </p>
              
              <h3 style={{ color: '#10b981', fontSize: '16px', marginTop: '24px', marginBottom: '12px' }}>7. Legislación aplicable</h3>
              <p style={{ marginBottom: '12px' }}>
                Estas condiciones se rigen por la legislación española. Para cualquier controversia serán competentes los Juzgados y Tribunales de Tarragona.
              </p>
              
              <p style={{ marginTop: '24px', fontSize: '12px', color: '#94a3b8' }}>Última actualización: Abril 2026</p>
            </div>
            
            <button onClick={() => setAvisoLegalOpen(false)} style={{ marginTop: '24px', width: '100%', padding: '12px', background: 'linear-gradient(135deg, #10b981, #059669)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>Cerrar</button>
          </div>
        </div>
      )}

      <footer>
        <div style={{ marginBottom: '12px' }}>
          <a href="https://www.instagram.com/javirepara_/" target="_blank" rel="noopener noreferrer" style={{ color: '#10b981', textDecoration: 'none', fontSize: '13px', fontWeight: '600' }}>
            📷 Síguenos en Instagram
          </a>
        </div>
        <div style={{ marginBottom: '12px', display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button onClick={() => setAvisoLegalOpen(true)} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: '11px', textDecoration: 'underline', cursor: 'pointer' }}>
            Aviso Legal
          </button>
          <button onClick={() => setPrivacidadOpen(true)} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: '11px', textDecoration: 'underline', cursor: 'pointer' }}>
            Política de Privacidad
          </button>
        </div>
        <div style={{ fontSize: '11px', color: '#64748b' }}>
          © 2026 JAVIREPARA • Reformas Profesionales
        </div>
      </footer>
    </div>
  );
}
